import * as R from "ramda";
import { assoc, assocPath, chain, clamp, defaultTo, filter, find, forEach, head, isEmpty, map, mergeDeepRight, mergeRight, path, pick, prop, propEq, zipObj } from "ramda";
import { Functional, LatLng, Ordinal, Wayfinding, WayfindingSegment } from "@wayfinder/vms-base";
import { LandscapeState } from "@wayfinder/vms-state";
import WebMercatorViewport from "viewport-mercator-project";
var __commonJSMin = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);
//#endregion
//#region ../../apps/vms/src/backend/reducers/define-action.js
const def$1 = (type, ...argNames) => (...args) => {
	const action = { type };
	argNames.forEach((arg, index) => {
		action[argNames[index]] = args[index];
	});
	return action;
};
//#endregion
//#region ../../node_modules/react/cjs/react.production.min.js
/**
* @license React
* react.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_production_min = /* @__PURE__ */ __commonJSMin(((exports) => {
	var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
	function A(a) {
		if (null === a || "object" !== typeof a) return null;
		a = z && a[z] || a["@@iterator"];
		return "function" === typeof a ? a : null;
	}
	var B = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, C = Object.assign, D = {};
	function E(a, b, e) {
		this.props = a;
		this.context = b;
		this.refs = D;
		this.updater = e || B;
	}
	E.prototype.isReactComponent = {};
	E.prototype.setState = function(a, b) {
		if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, a, b, "setState");
	};
	E.prototype.forceUpdate = function(a) {
		this.updater.enqueueForceUpdate(this, a, "forceUpdate");
	};
	function F() {}
	F.prototype = E.prototype;
	function G(a, b, e) {
		this.props = a;
		this.context = b;
		this.refs = D;
		this.updater = e || B;
	}
	var H = G.prototype = new F();
	H.constructor = G;
	C(H, E.prototype);
	H.isPureReactComponent = !0;
	var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = { current: null }, L = {
		key: !0,
		ref: !0,
		__self: !0,
		__source: !0
	};
	function M(a, b, e) {
		var d, c = {}, k = null, h = null;
		if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
		var g = arguments.length - 2;
		if (1 === g) c.children = e;
		else if (1 < g) {
			for (var f = Array(g), m = 0; m < g; m++) f[m] = arguments[m + 2];
			c.children = f;
		}
		if (a && a.defaultProps) for (d in g = a.defaultProps, g) void 0 === c[d] && (c[d] = g[d]);
		return {
			$$typeof: l,
			type: a,
			key: k,
			ref: h,
			props: c,
			_owner: K.current
		};
	}
	function N(a, b) {
		return {
			$$typeof: l,
			type: a.type,
			key: b,
			ref: a.ref,
			props: a.props,
			_owner: a._owner
		};
	}
	function O(a) {
		return "object" === typeof a && null !== a && a.$$typeof === l;
	}
	function escape(a) {
		var b = {
			"=": "=0",
			":": "=2"
		};
		return "$" + a.replace(/[=:]/g, function(a) {
			return b[a];
		});
	}
	var P = /\/+/g;
	function Q(a, b) {
		return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
	}
	function R(a, b, e, d, c) {
		var k = typeof a;
		if ("undefined" === k || "boolean" === k) a = null;
		var h = !1;
		if (null === a) h = !0;
		else switch (k) {
			case "string":
			case "number":
				h = !0;
				break;
			case "object": switch (a.$$typeof) {
				case l:
				case n: h = !0;
			}
		}
		if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
			return a;
		})) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
		h = 0;
		d = "" === d ? "." : d + ":";
		if (I(a)) for (var g = 0; g < a.length; g++) {
			k = a[g];
			var f = d + Q(k, g);
			h += R(k, b, e, f, c);
		}
		else if (f = A(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done;) k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
		else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
		return h;
	}
	function S(a, b, e) {
		if (null == a) return a;
		var d = [], c = 0;
		R(a, d, "", "", function(a) {
			return b.call(e, a, c++);
		});
		return d;
	}
	function T(a) {
		if (-1 === a._status) {
			var b = a._result;
			b = b();
			b.then(function(b) {
				if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
			}, function(b) {
				if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
			});
			-1 === a._status && (a._status = 0, a._result = b);
		}
		if (1 === a._status) return a._result.default;
		throw a._result;
	}
	var U = { current: null }, V = { transition: null }, W = {
		ReactCurrentDispatcher: U,
		ReactCurrentBatchConfig: V,
		ReactCurrentOwner: K
	};
	function X() {
		throw Error("act(...) is not supported in production builds of React.");
	}
	exports.Children = {
		map: S,
		forEach: function(a, b, e) {
			S(a, function() {
				b.apply(this, arguments);
			}, e);
		},
		count: function(a) {
			var b = 0;
			S(a, function() {
				b++;
			});
			return b;
		},
		toArray: function(a) {
			return S(a, function(a) {
				return a;
			}) || [];
		},
		only: function(a) {
			if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
			return a;
		}
	};
	exports.Component = E;
	exports.Fragment = p;
	exports.Profiler = r;
	exports.PureComponent = G;
	exports.StrictMode = q;
	exports.Suspense = w;
	exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
	exports.act = X;
	exports.cloneElement = function(a, b, e) {
		if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
		var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
		if (null != b) {
			void 0 !== b.ref && (k = b.ref, h = K.current);
			void 0 !== b.key && (c = "" + b.key);
			if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
			for (f in b) J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
		}
		var f = arguments.length - 2;
		if (1 === f) d.children = e;
		else if (1 < f) {
			g = Array(f);
			for (var m = 0; m < f; m++) g[m] = arguments[m + 2];
			d.children = g;
		}
		return {
			$$typeof: l,
			type: a.type,
			key: c,
			ref: k,
			props: d,
			_owner: h
		};
	};
	exports.createContext = function(a) {
		a = {
			$$typeof: u,
			_currentValue: a,
			_currentValue2: a,
			_threadCount: 0,
			Provider: null,
			Consumer: null,
			_defaultValue: null,
			_globalName: null
		};
		a.Provider = {
			$$typeof: t,
			_context: a
		};
		return a.Consumer = a;
	};
	exports.createElement = M;
	exports.createFactory = function(a) {
		var b = M.bind(null, a);
		b.type = a;
		return b;
	};
	exports.createRef = function() {
		return { current: null };
	};
	exports.forwardRef = function(a) {
		return {
			$$typeof: v,
			render: a
		};
	};
	exports.isValidElement = O;
	exports.lazy = function(a) {
		return {
			$$typeof: y,
			_payload: {
				_status: -1,
				_result: a
			},
			_init: T
		};
	};
	exports.memo = function(a, b) {
		return {
			$$typeof: x,
			type: a,
			compare: void 0 === b ? null : b
		};
	};
	exports.startTransition = function(a) {
		var b = V.transition;
		V.transition = {};
		try {
			a();
		} finally {
			V.transition = b;
		}
	};
	exports.unstable_act = X;
	exports.useCallback = function(a, b) {
		return U.current.useCallback(a, b);
	};
	exports.useContext = function(a) {
		return U.current.useContext(a);
	};
	exports.useDebugValue = function() {};
	exports.useDeferredValue = function(a) {
		return U.current.useDeferredValue(a);
	};
	exports.useEffect = function(a, b) {
		return U.current.useEffect(a, b);
	};
	exports.useId = function() {
		return U.current.useId();
	};
	exports.useImperativeHandle = function(a, b, e) {
		return U.current.useImperativeHandle(a, b, e);
	};
	exports.useInsertionEffect = function(a, b) {
		return U.current.useInsertionEffect(a, b);
	};
	exports.useLayoutEffect = function(a, b) {
		return U.current.useLayoutEffect(a, b);
	};
	exports.useMemo = function(a, b) {
		return U.current.useMemo(a, b);
	};
	exports.useReducer = function(a, b, e) {
		return U.current.useReducer(a, b, e);
	};
	exports.useRef = function(a) {
		return U.current.useRef(a);
	};
	exports.useState = function(a) {
		return U.current.useState(a);
	};
	exports.useSyncExternalStore = function(a, b, e) {
		return U.current.useSyncExternalStore(a, b, e);
	};
	exports.useTransition = function() {
		return U.current.useTransition();
	};
	exports.version = "18.3.1";
}));
//#endregion
//#region ../../node_modules/react/cjs/react.development.js
/**
* @license React
* react.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_development = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV !== "production") (function() {
		"use strict";
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ new Error());
		var ReactVersion = "18.3.1";
		var REACT_ELEMENT_TYPE = Symbol.for("react.element");
		var REACT_PORTAL_TYPE = Symbol.for("react.portal");
		var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
		var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
		var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
		var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
		var REACT_CONTEXT_TYPE = Symbol.for("react.context");
		var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
		var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
		var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
		var REACT_MEMO_TYPE = Symbol.for("react.memo");
		var REACT_LAZY_TYPE = Symbol.for("react.lazy");
		var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
		var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = "@@iterator";
		function getIteratorFn(maybeIterable) {
			if (maybeIterable === null || typeof maybeIterable !== "object") return null;
			var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
			if (typeof maybeIterator === "function") return maybeIterator;
			return null;
		}
		/**
		* Keeps track of the current dispatcher.
		*/
		var ReactCurrentDispatcher = { current: null };
		/**
		* Keeps track of the current batch's configuration such as how long an update
		* should suspend for if it needs to.
		*/
		var ReactCurrentBatchConfig = { transition: null };
		var ReactCurrentActQueue = {
			current: null,
			isBatchingLegacy: false,
			didScheduleLegacyUpdate: false
		};
		/**
		* Keeps track of the current owner.
		*
		* The current owner is the component who should own any components that are
		* currently being constructed.
		*/
		var ReactCurrentOwner = { current: null };
		var ReactDebugCurrentFrame = {};
		var currentExtraStackFrame = null;
		function setExtraStackFrame(stack) {
			currentExtraStackFrame = stack;
		}
		ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
			currentExtraStackFrame = stack;
		};
		ReactDebugCurrentFrame.getCurrentStack = null;
		ReactDebugCurrentFrame.getStackAddendum = function() {
			var stack = "";
			if (currentExtraStackFrame) stack += currentExtraStackFrame;
			var impl = ReactDebugCurrentFrame.getCurrentStack;
			if (impl) stack += impl() || "";
			return stack;
		};
		var enableScopeAPI = false;
		var enableCacheElement = false;
		var enableTransitionTracing = false;
		var enableLegacyHidden = false;
		var enableDebugTracing = false;
		var ReactSharedInternals = {
			ReactCurrentDispatcher,
			ReactCurrentBatchConfig,
			ReactCurrentOwner
		};
		ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
		ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
		function warn(format) {
			for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
			printWarning("warn", format, args);
		}
		function error(format) {
			for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
			printWarning("error", format, args);
		}
		function printWarning(level, format, args) {
			var stack = ReactSharedInternals.ReactDebugCurrentFrame.getStackAddendum();
			if (stack !== "") {
				format += "%s";
				args = args.concat([stack]);
			}
			var argsWithFormat = args.map(function(item) {
				return String(item);
			});
			argsWithFormat.unshift("Warning: " + format);
			Function.prototype.apply.call(console[level], console, argsWithFormat);
		}
		var didWarnStateUpdateForUnmountedComponent = {};
		function warnNoop(publicInstance, callerName) {
			var _constructor = publicInstance.constructor;
			var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
			var warningKey = componentName + "." + callerName;
			if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
			error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
			didWarnStateUpdateForUnmountedComponent[warningKey] = true;
		}
		/**
		* This is the abstract API for an update queue.
		*/
		var ReactNoopUpdateQueue = {
			isMounted: function(publicInstance) {
				return false;
			},
			enqueueForceUpdate: function(publicInstance, callback, callerName) {
				warnNoop(publicInstance, "forceUpdate");
			},
			enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
				warnNoop(publicInstance, "replaceState");
			},
			enqueueSetState: function(publicInstance, partialState, callback, callerName) {
				warnNoop(publicInstance, "setState");
			}
		};
		var assign = Object.assign;
		var emptyObject = {};
		Object.freeze(emptyObject);
		/**
		* Base class helpers for the updating state of a component.
		*/
		function Component(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		Component.prototype.isReactComponent = {};
		/**
		* Sets a subset of the state. Always use this to mutate
		* state. You should treat `this.state` as immutable.
		*
		* There is no guarantee that `this.state` will be immediately updated, so
		* accessing `this.state` after calling this method may return the old value.
		*
		* There is no guarantee that calls to `setState` will run synchronously,
		* as they may eventually be batched together.  You can provide an optional
		* callback that will be executed when the call to setState is actually
		* completed.
		*
		* When a function is provided to setState, it will be called at some point in
		* the future (not synchronously). It will be called with the up to date
		* component arguments (state, props, context). These values can be different
		* from this.* because your function may be called after receiveProps but before
		* shouldComponentUpdate, and this new state, props, and context will not yet be
		* assigned to this.
		*
		* @param {object|function} partialState Next partial state or function to
		*        produce next partial state to be merged with current state.
		* @param {?function} callback Called after state is updated.
		* @final
		* @protected
		*/
		Component.prototype.setState = function(partialState, callback) {
			if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, partialState, callback, "setState");
		};
		/**
		* Forces an update. This should only be invoked when it is known with
		* certainty that we are **not** in a DOM transaction.
		*
		* You may want to call this when you know that some deeper aspect of the
		* component's state has changed but `setState` was not called.
		*
		* This will not invoke `shouldComponentUpdate`, but it will invoke
		* `componentWillUpdate` and `componentDidUpdate`.
		*
		* @param {?function} callback Called after update is complete.
		* @final
		* @protected
		*/
		Component.prototype.forceUpdate = function(callback) {
			this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
		};
		var deprecatedAPIs = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		var defineDeprecationWarning = function(methodName, info) {
			Object.defineProperty(Component.prototype, methodName, { get: function() {
				warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
			} });
		};
		for (var fnName in deprecatedAPIs) if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
		function ComponentDummy() {}
		ComponentDummy.prototype = Component.prototype;
		/**
		* Convenience component with default shallow equality check for sCU.
		*/
		function PureComponent(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
		pureComponentPrototype.constructor = PureComponent;
		assign(pureComponentPrototype, Component.prototype);
		pureComponentPrototype.isPureReactComponent = true;
		function createRef() {
			var refObject = { current: null };
			Object.seal(refObject);
			return refObject;
		}
		var isArrayImpl = Array.isArray;
		function isArray(a) {
			return isArrayImpl(a);
		}
		function typeName(value) {
			return typeof Symbol === "function" && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
		}
		function willCoercionThrow(value) {
			try {
				testStringCoercion(value);
				return false;
			} catch (e) {
				return true;
			}
		}
		function testStringCoercion(value) {
			return "" + value;
		}
		function checkKeyStringCoercion(value) {
			if (willCoercionThrow(value)) {
				error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
				return testStringCoercion(value);
			}
		}
		function getWrappedName(outerType, innerType, wrapperName) {
			var displayName = outerType.displayName;
			if (displayName) return displayName;
			var functionName = innerType.displayName || innerType.name || "";
			return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
		}
		function getContextName(type) {
			return type.displayName || "Context";
		}
		function getComponentNameFromType(type) {
			if (type == null) return null;
			if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
			if (typeof type === "function") return type.displayName || type.name || null;
			if (typeof type === "string") return type;
			switch (type) {
				case REACT_FRAGMENT_TYPE: return "Fragment";
				case REACT_PORTAL_TYPE: return "Portal";
				case REACT_PROFILER_TYPE: return "Profiler";
				case REACT_STRICT_MODE_TYPE: return "StrictMode";
				case REACT_SUSPENSE_TYPE: return "Suspense";
				case REACT_SUSPENSE_LIST_TYPE: return "SuspenseList";
			}
			if (typeof type === "object") switch (type.$$typeof) {
				case REACT_CONTEXT_TYPE: return getContextName(type) + ".Consumer";
				case REACT_PROVIDER_TYPE: return getContextName(type._context) + ".Provider";
				case REACT_FORWARD_REF_TYPE: return getWrappedName(type, type.render, "ForwardRef");
				case REACT_MEMO_TYPE:
					var outerName = type.displayName || null;
					if (outerName !== null) return outerName;
					return getComponentNameFromType(type.type) || "Memo";
				case REACT_LAZY_TYPE:
					var lazyComponent = type;
					var payload = lazyComponent._payload;
					var init = lazyComponent._init;
					try {
						return getComponentNameFromType(init(payload));
					} catch (x) {
						return null;
					}
			}
			return null;
		}
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var RESERVED_PROPS = {
			key: true,
			ref: true,
			__self: true,
			__source: true
		};
		var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs = {};
		function hasValidRef(config) {
			if (hasOwnProperty.call(config, "ref")) {
				var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
				if (getter && getter.isReactWarning) return false;
			}
			return config.ref !== void 0;
		}
		function hasValidKey(config) {
			if (hasOwnProperty.call(config, "key")) {
				var getter = Object.getOwnPropertyDescriptor(config, "key").get;
				if (getter && getter.isReactWarning) return false;
			}
			return config.key !== void 0;
		}
		function defineKeyPropWarningGetter(props, displayName) {
			var warnAboutAccessingKey = function() {
				if (!specialPropKeyWarningShown) {
					specialPropKeyWarningShown = true;
					error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
				}
			};
			warnAboutAccessingKey.isReactWarning = true;
			Object.defineProperty(props, "key", {
				get: warnAboutAccessingKey,
				configurable: true
			});
		}
		function defineRefPropWarningGetter(props, displayName) {
			var warnAboutAccessingRef = function() {
				if (!specialPropRefWarningShown) {
					specialPropRefWarningShown = true;
					error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
				}
			};
			warnAboutAccessingRef.isReactWarning = true;
			Object.defineProperty(props, "ref", {
				get: warnAboutAccessingRef,
				configurable: true
			});
		}
		function warnIfStringRefCannotBeAutoConverted(config) {
			if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
				var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
				if (!didWarnAboutStringRefs[componentName]) {
					error("Component \"%s\" contains the string ref \"%s\". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref", componentName, config.ref);
					didWarnAboutStringRefs[componentName] = true;
				}
			}
		}
		/**
		* Factory method to create a new React element. This no longer adheres to
		* the class pattern, so do not use new to call it. Also, instanceof check
		* will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		* if something is a React Element.
		*
		* @param {*} type
		* @param {*} props
		* @param {*} key
		* @param {string|object} ref
		* @param {*} owner
		* @param {*} self A *temporary* helper to detect places where `this` is
		* different from the `owner` when React.createElement is called, so that we
		* can warn. We want to get rid of owner and replace string `ref`s with arrow
		* functions, and as long as `this` and owner are the same, there will be no
		* change in behavior.
		* @param {*} source An annotation object (added by a transpiler or otherwise)
		* indicating filename, line number, and/or other information.
		* @internal
		*/
		var ReactElement = function(type, key, ref, self, source, owner, props) {
			var element = {
				$$typeof: REACT_ELEMENT_TYPE,
				type,
				key,
				ref,
				props,
				_owner: owner
			};
			element._store = {};
			Object.defineProperty(element._store, "validated", {
				configurable: false,
				enumerable: false,
				writable: true,
				value: false
			});
			Object.defineProperty(element, "_self", {
				configurable: false,
				enumerable: false,
				writable: false,
				value: self
			});
			Object.defineProperty(element, "_source", {
				configurable: false,
				enumerable: false,
				writable: false,
				value: source
			});
			if (Object.freeze) {
				Object.freeze(element.props);
				Object.freeze(element);
			}
			return element;
		};
		/**
		* Create and return a new ReactElement of the given type.
		* See https://reactjs.org/docs/react-api.html#createelement
		*/
		function createElement(type, config, children) {
			var propName;
			var props = {};
			var key = null;
			var ref = null;
			var self = null;
			var source = null;
			if (config != null) {
				if (hasValidRef(config)) {
					ref = config.ref;
					warnIfStringRefCannotBeAutoConverted(config);
				}
				if (hasValidKey(config)) {
					checkKeyStringCoercion(config.key);
					key = "" + config.key;
				}
				self = config.__self === void 0 ? null : config.__self;
				source = config.__source === void 0 ? null : config.__source;
				for (propName in config) if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
			}
			var childrenLength = arguments.length - 2;
			if (childrenLength === 1) props.children = children;
			else if (childrenLength > 1) {
				var childArray = Array(childrenLength);
				for (var i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 2];
				if (Object.freeze) Object.freeze(childArray);
				props.children = childArray;
			}
			if (type && type.defaultProps) {
				var defaultProps = type.defaultProps;
				for (propName in defaultProps) if (props[propName] === void 0) props[propName] = defaultProps[propName];
			}
			if (key || ref) {
				var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
				if (key) defineKeyPropWarningGetter(props, displayName);
				if (ref) defineRefPropWarningGetter(props, displayName);
			}
			return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		}
		function cloneAndReplaceKey(oldElement, newKey) {
			return ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
		}
		/**
		* Clone and return a new ReactElement using element as the starting point.
		* See https://reactjs.org/docs/react-api.html#cloneelement
		*/
		function cloneElement(element, config, children) {
			if (element === null || element === void 0) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
			var propName;
			var props = assign({}, element.props);
			var key = element.key;
			var ref = element.ref;
			var self = element._self;
			var source = element._source;
			var owner = element._owner;
			if (config != null) {
				if (hasValidRef(config)) {
					ref = config.ref;
					owner = ReactCurrentOwner.current;
				}
				if (hasValidKey(config)) {
					checkKeyStringCoercion(config.key);
					key = "" + config.key;
				}
				var defaultProps;
				if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
				for (propName in config) if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) if (config[propName] === void 0 && defaultProps !== void 0) props[propName] = defaultProps[propName];
				else props[propName] = config[propName];
			}
			var childrenLength = arguments.length - 2;
			if (childrenLength === 1) props.children = children;
			else if (childrenLength > 1) {
				var childArray = Array(childrenLength);
				for (var i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 2];
				props.children = childArray;
			}
			return ReactElement(element.type, key, ref, self, source, owner, props);
		}
		/**
		* Verifies the object is a ReactElement.
		* See https://reactjs.org/docs/react-api.html#isvalidelement
		* @param {?object} object
		* @return {boolean} True if `object` is a ReactElement.
		* @final
		*/
		function isValidElement(object) {
			return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		}
		var SEPARATOR = ".";
		var SUBSEPARATOR = ":";
		/**
		* Escape and wrap key so it is safe to use as a reactid
		*
		* @param {string} key to be escaped.
		* @return {string} the escaped key.
		*/
		function escape(key) {
			var escapeRegex = /[=:]/g;
			var escaperLookup = {
				"=": "=0",
				":": "=2"
			};
			return "$" + key.replace(escapeRegex, function(match) {
				return escaperLookup[match];
			});
		}
		/**
		* TODO: Test that a single child and an array with one item have the same key
		* pattern.
		*/
		var didWarnAboutMaps = false;
		var userProvidedKeyEscapeRegex = /\/+/g;
		function escapeUserProvidedKey(text) {
			return text.replace(userProvidedKeyEscapeRegex, "$&/");
		}
		/**
		* Generate a key string that identifies a element within a set.
		*
		* @param {*} element A element that could contain a manual key.
		* @param {number} index Index that is used if a manual key is not provided.
		* @return {string}
		*/
		function getElementKey(element, index) {
			if (typeof element === "object" && element !== null && element.key != null) {
				checkKeyStringCoercion(element.key);
				return escape("" + element.key);
			}
			return index.toString(36);
		}
		function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
			var type = typeof children;
			if (type === "undefined" || type === "boolean") children = null;
			var invokeCallback = false;
			if (children === null) invokeCallback = true;
			else switch (type) {
				case "string":
				case "number":
					invokeCallback = true;
					break;
				case "object": switch (children.$$typeof) {
					case REACT_ELEMENT_TYPE:
					case REACT_PORTAL_TYPE: invokeCallback = true;
				}
			}
			if (invokeCallback) {
				var _child = children;
				var mappedChild = callback(_child);
				var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
				if (isArray(mappedChild)) {
					var escapedChildKey = "";
					if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
					mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
						return c;
					});
				} else if (mappedChild != null) {
					if (isValidElement(mappedChild)) {
						if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
						mappedChild = cloneAndReplaceKey(mappedChild, escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
					}
					array.push(mappedChild);
				}
				return 1;
			}
			var child;
			var nextName;
			var subtreeCount = 0;
			var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
			if (isArray(children)) for (var i = 0; i < children.length; i++) {
				child = children[i];
				nextName = nextNamePrefix + getElementKey(child, i);
				subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
			}
			else {
				var iteratorFn = getIteratorFn(children);
				if (typeof iteratorFn === "function") {
					var iterableChildren = children;
					if (iteratorFn === iterableChildren.entries) {
						if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
						didWarnAboutMaps = true;
					}
					var iterator = iteratorFn.call(iterableChildren);
					var step;
					var ii = 0;
					while (!(step = iterator.next()).done) {
						child = step.value;
						nextName = nextNamePrefix + getElementKey(child, ii++);
						subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
					}
				} else if (type === "object") {
					var childrenString = String(children);
					throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). If you meant to render a collection of children, use an array instead.");
				}
			}
			return subtreeCount;
		}
		/**
		* Maps children that are typically specified as `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenmap
		*
		* The provided mapFunction(child, index) will be called for each
		* leaf child.
		*
		* @param {?*} children Children tree container.
		* @param {function(*, int)} func The map function.
		* @param {*} context Context for mapFunction.
		* @return {object} Object containing the ordered map of results.
		*/
		function mapChildren(children, func, context) {
			if (children == null) return children;
			var result = [];
			var count = 0;
			mapIntoArray(children, result, "", "", function(child) {
				return func.call(context, child, count++);
			});
			return result;
		}
		/**
		* Count the number of children that are typically specified as
		* `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrencount
		*
		* @param {?*} children Children tree container.
		* @return {number} The number of children.
		*/
		function countChildren(children) {
			var n = 0;
			mapChildren(children, function() {
				n++;
			});
			return n;
		}
		/**
		* Iterates through children that are typically specified as `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenforeach
		*
		* The provided forEachFunc(child, index) will be called for each
		* leaf child.
		*
		* @param {?*} children Children tree container.
		* @param {function(*, int)} forEachFunc
		* @param {*} forEachContext Context for forEachContext.
		*/
		function forEachChildren(children, forEachFunc, forEachContext) {
			mapChildren(children, function() {
				forEachFunc.apply(this, arguments);
			}, forEachContext);
		}
		/**
		* Flatten a children object (typically specified as `props.children`) and
		* return an array with appropriately re-keyed children.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrentoarray
		*/
		function toArray(children) {
			return mapChildren(children, function(child) {
				return child;
			}) || [];
		}
		/**
		* Returns the first child in a collection of children and verifies that there
		* is only one child in the collection.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenonly
		*
		* The current implementation of this function assumes that a single child gets
		* passed without a wrapper, but the purpose of this helper function is to
		* abstract away the particular structure of children.
		*
		* @param {?object} children Child collection structure.
		* @return {ReactElement} The first and only `ReactElement` contained in the
		* structure.
		*/
		function onlyChild(children) {
			if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
			return children;
		}
		function createContext(defaultValue) {
			var context = {
				$$typeof: REACT_CONTEXT_TYPE,
				_currentValue: defaultValue,
				_currentValue2: defaultValue,
				_threadCount: 0,
				Provider: null,
				Consumer: null,
				_defaultValue: null,
				_globalName: null
			};
			context.Provider = {
				$$typeof: REACT_PROVIDER_TYPE,
				_context: context
			};
			var hasWarnedAboutUsingNestedContextConsumers = false;
			var hasWarnedAboutUsingConsumerProvider = false;
			var hasWarnedAboutDisplayNameOnConsumer = false;
			var Consumer = {
				$$typeof: REACT_CONTEXT_TYPE,
				_context: context
			};
			Object.defineProperties(Consumer, {
				Provider: {
					get: function() {
						if (!hasWarnedAboutUsingConsumerProvider) {
							hasWarnedAboutUsingConsumerProvider = true;
							error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
						}
						return context.Provider;
					},
					set: function(_Provider) {
						context.Provider = _Provider;
					}
				},
				_currentValue: {
					get: function() {
						return context._currentValue;
					},
					set: function(_currentValue) {
						context._currentValue = _currentValue;
					}
				},
				_currentValue2: {
					get: function() {
						return context._currentValue2;
					},
					set: function(_currentValue2) {
						context._currentValue2 = _currentValue2;
					}
				},
				_threadCount: {
					get: function() {
						return context._threadCount;
					},
					set: function(_threadCount) {
						context._threadCount = _threadCount;
					}
				},
				Consumer: { get: function() {
					if (!hasWarnedAboutUsingNestedContextConsumers) {
						hasWarnedAboutUsingNestedContextConsumers = true;
						error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
					}
					return context.Consumer;
				} },
				displayName: {
					get: function() {
						return context.displayName;
					},
					set: function(displayName) {
						if (!hasWarnedAboutDisplayNameOnConsumer) {
							warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
							hasWarnedAboutDisplayNameOnConsumer = true;
						}
					}
				}
			});
			context.Consumer = Consumer;
			context._currentRenderer = null;
			context._currentRenderer2 = null;
			return context;
		}
		var Uninitialized = -1;
		var Pending = 0;
		var Resolved = 1;
		var Rejected = 2;
		function lazyInitializer(payload) {
			if (payload._status === Uninitialized) {
				var ctor = payload._result;
				var thenable = ctor();
				thenable.then(function(moduleObject) {
					if (payload._status === Pending || payload._status === Uninitialized) {
						var resolved = payload;
						resolved._status = Resolved;
						resolved._result = moduleObject;
					}
				}, function(error) {
					if (payload._status === Pending || payload._status === Uninitialized) {
						var rejected = payload;
						rejected._status = Rejected;
						rejected._result = error;
					}
				});
				if (payload._status === Uninitialized) {
					var pending = payload;
					pending._status = Pending;
					pending._result = thenable;
				}
			}
			if (payload._status === Resolved) {
				var moduleObject = payload._result;
				if (moduleObject === void 0) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
				if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
				return moduleObject.default;
			} else throw payload._result;
		}
		function lazy(ctor) {
			var lazyType = {
				$$typeof: REACT_LAZY_TYPE,
				_payload: {
					_status: Uninitialized,
					_result: ctor
				},
				_init: lazyInitializer
			};
			var defaultProps;
			var propTypes;
			Object.defineProperties(lazyType, {
				defaultProps: {
					configurable: true,
					get: function() {
						return defaultProps;
					},
					set: function(newDefaultProps) {
						error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
						defaultProps = newDefaultProps;
						Object.defineProperty(lazyType, "defaultProps", { enumerable: true });
					}
				},
				propTypes: {
					configurable: true,
					get: function() {
						return propTypes;
					},
					set: function(newPropTypes) {
						error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
						propTypes = newPropTypes;
						Object.defineProperty(lazyType, "propTypes", { enumerable: true });
					}
				}
			});
			return lazyType;
		}
		function forwardRef(render) {
			if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
			else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
			else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
			if (render != null) {
				if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
			}
			var elementType = {
				$$typeof: REACT_FORWARD_REF_TYPE,
				render
			};
			var ownName;
			Object.defineProperty(elementType, "displayName", {
				enumerable: false,
				configurable: true,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					if (!render.name && !render.displayName) render.displayName = name;
				}
			});
			return elementType;
		}
		var REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
		function isValidElementType(type) {
			if (typeof type === "string" || typeof type === "function") return true;
			if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
			if (typeof type === "object" && type !== null) {
				if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) return true;
			}
			return false;
		}
		function memo(type, compare) {
			if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
			var elementType = {
				$$typeof: REACT_MEMO_TYPE,
				type,
				compare: compare === void 0 ? null : compare
			};
			var ownName;
			Object.defineProperty(elementType, "displayName", {
				enumerable: false,
				configurable: true,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					if (!type.name && !type.displayName) type.displayName = name;
				}
			});
			return elementType;
		}
		function resolveDispatcher() {
			var dispatcher = ReactCurrentDispatcher.current;
			if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
			return dispatcher;
		}
		function useContext(Context) {
			var dispatcher = resolveDispatcher();
			if (Context._context !== void 0) {
				var realContext = Context._context;
				if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
				else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
			}
			return dispatcher.useContext(Context);
		}
		function useState(initialState) {
			return resolveDispatcher().useState(initialState);
		}
		function useReducer(reducer, initialArg, init) {
			return resolveDispatcher().useReducer(reducer, initialArg, init);
		}
		function useRef(initialValue) {
			return resolveDispatcher().useRef(initialValue);
		}
		function useEffect(create, deps) {
			return resolveDispatcher().useEffect(create, deps);
		}
		function useInsertionEffect(create, deps) {
			return resolveDispatcher().useInsertionEffect(create, deps);
		}
		function useLayoutEffect(create, deps) {
			return resolveDispatcher().useLayoutEffect(create, deps);
		}
		function useCallback(callback, deps) {
			return resolveDispatcher().useCallback(callback, deps);
		}
		function useMemo(create, deps) {
			return resolveDispatcher().useMemo(create, deps);
		}
		function useImperativeHandle(ref, create, deps) {
			return resolveDispatcher().useImperativeHandle(ref, create, deps);
		}
		function useDebugValue(value, formatterFn) {
			return resolveDispatcher().useDebugValue(value, formatterFn);
		}
		function useTransition() {
			return resolveDispatcher().useTransition();
		}
		function useDeferredValue(value) {
			return resolveDispatcher().useDeferredValue(value);
		}
		function useId() {
			return resolveDispatcher().useId();
		}
		function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
			return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
		}
		var disabledDepth = 0;
		var prevLog;
		var prevInfo;
		var prevWarn;
		var prevError;
		var prevGroup;
		var prevGroupCollapsed;
		var prevGroupEnd;
		function disabledLog() {}
		disabledLog.__reactDisabledLog = true;
		function disableLogs() {
			if (disabledDepth === 0) {
				prevLog = console.log;
				prevInfo = console.info;
				prevWarn = console.warn;
				prevError = console.error;
				prevGroup = console.group;
				prevGroupCollapsed = console.groupCollapsed;
				prevGroupEnd = console.groupEnd;
				var props = {
					configurable: true,
					enumerable: true,
					value: disabledLog,
					writable: true
				};
				Object.defineProperties(console, {
					info: props,
					log: props,
					warn: props,
					error: props,
					group: props,
					groupCollapsed: props,
					groupEnd: props
				});
			}
			disabledDepth++;
		}
		function reenableLogs() {
			disabledDepth--;
			if (disabledDepth === 0) {
				var props = {
					configurable: true,
					enumerable: true,
					writable: true
				};
				Object.defineProperties(console, {
					log: assign({}, props, { value: prevLog }),
					info: assign({}, props, { value: prevInfo }),
					warn: assign({}, props, { value: prevWarn }),
					error: assign({}, props, { value: prevError }),
					group: assign({}, props, { value: prevGroup }),
					groupCollapsed: assign({}, props, { value: prevGroupCollapsed }),
					groupEnd: assign({}, props, { value: prevGroupEnd })
				});
			}
			if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
		}
		var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
		var prefix;
		function describeBuiltInComponentFrame(name, source, ownerFn) {
			if (prefix === void 0) try {
				throw Error();
			} catch (x) {
				var match = x.stack.trim().match(/\n( *(at )?)/);
				prefix = match && match[1] || "";
			}
			return "\n" + prefix + name;
		}
		var reentry = false;
		var componentFrameCache = new (typeof WeakMap === "function" ? WeakMap : Map)();
		function describeNativeComponentFrame(fn, construct) {
			if (!fn || reentry) return "";
			var frame = componentFrameCache.get(fn);
			if (frame !== void 0) return frame;
			var control;
			reentry = true;
			var previousPrepareStackTrace = Error.prepareStackTrace;
			Error.prepareStackTrace = void 0;
			var previousDispatcher = ReactCurrentDispatcher$1.current;
			ReactCurrentDispatcher$1.current = null;
			disableLogs();
			try {
				if (construct) {
					var Fake = function() {
						throw Error();
					};
					Object.defineProperty(Fake.prototype, "props", { set: function() {
						throw Error();
					} });
					if (typeof Reflect === "object" && Reflect.construct) {
						try {
							Reflect.construct(Fake, []);
						} catch (x) {
							control = x;
						}
						Reflect.construct(fn, [], Fake);
					} else {
						try {
							Fake.call();
						} catch (x) {
							control = x;
						}
						fn.call(Fake.prototype);
					}
				} else {
					try {
						throw Error();
					} catch (x) {
						control = x;
					}
					fn();
				}
			} catch (sample) {
				if (sample && control && typeof sample.stack === "string") {
					var sampleLines = sample.stack.split("\n");
					var controlLines = control.stack.split("\n");
					var s = sampleLines.length - 1;
					var c = controlLines.length - 1;
					while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) c--;
					for (; s >= 1 && c >= 0; s--, c--) if (sampleLines[s] !== controlLines[c]) {
						if (s !== 1 || c !== 1) do {
							s--;
							c--;
							if (c < 0 || sampleLines[s] !== controlLines[c]) {
								var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
								if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
								if (typeof fn === "function") componentFrameCache.set(fn, _frame);
								return _frame;
							}
						} while (s >= 1 && c >= 0);
						break;
					}
				}
			} finally {
				reentry = false;
				ReactCurrentDispatcher$1.current = previousDispatcher;
				reenableLogs();
				Error.prepareStackTrace = previousPrepareStackTrace;
			}
			var name = fn ? fn.displayName || fn.name : "";
			var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
			if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
			return syntheticFrame;
		}
		function describeFunctionComponentFrame(fn, source, ownerFn) {
			return describeNativeComponentFrame(fn, false);
		}
		function shouldConstruct(Component) {
			var prototype = Component.prototype;
			return !!(prototype && prototype.isReactComponent);
		}
		function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
			if (type == null) return "";
			if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
			if (typeof type === "string") return describeBuiltInComponentFrame(type);
			switch (type) {
				case REACT_SUSPENSE_TYPE: return describeBuiltInComponentFrame("Suspense");
				case REACT_SUSPENSE_LIST_TYPE: return describeBuiltInComponentFrame("SuspenseList");
			}
			if (typeof type === "object") switch (type.$$typeof) {
				case REACT_FORWARD_REF_TYPE: return describeFunctionComponentFrame(type.render);
				case REACT_MEMO_TYPE: return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
				case REACT_LAZY_TYPE:
					var lazyComponent = type;
					var payload = lazyComponent._payload;
					var init = lazyComponent._init;
					try {
						return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
					} catch (x) {}
			}
			return "";
		}
		var loggedTypeFailures = {};
		var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
		function setCurrentlyValidatingElement(element) {
			if (element) {
				var owner = element._owner;
				var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
				ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
			} else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		}
		function checkPropTypes(typeSpecs, values, location, componentName, element) {
			var has = Function.call.bind(hasOwnProperty);
			for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
				var error$1 = void 0;
				try {
					if (typeof typeSpecs[typeSpecName] !== "function") {
						var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						err.name = "Invariant Violation";
						throw err;
					}
					error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
				} catch (ex) {
					error$1 = ex;
				}
				if (error$1 && !(error$1 instanceof Error)) {
					setCurrentlyValidatingElement(element);
					error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
					setCurrentlyValidatingElement(null);
				}
				if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
					loggedTypeFailures[error$1.message] = true;
					setCurrentlyValidatingElement(element);
					error("Failed %s type: %s", location, error$1.message);
					setCurrentlyValidatingElement(null);
				}
			}
		}
		function setCurrentlyValidatingElement$1(element) {
			if (element) {
				var owner = element._owner;
				setExtraStackFrame(describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null));
			} else setExtraStackFrame(null);
		}
		var propTypesMisspellWarningShown = false;
		function getDeclarationErrorAddendum() {
			if (ReactCurrentOwner.current) {
				var name = getComponentNameFromType(ReactCurrentOwner.current.type);
				if (name) return "\n\nCheck the render method of `" + name + "`.";
			}
			return "";
		}
		function getSourceInfoErrorAddendum(source) {
			if (source !== void 0) {
				var fileName = source.fileName.replace(/^.*[\\\/]/, "");
				var lineNumber = source.lineNumber;
				return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
			}
			return "";
		}
		function getSourceInfoErrorAddendumForProps(elementProps) {
			if (elementProps !== null && elementProps !== void 0) return getSourceInfoErrorAddendum(elementProps.__source);
			return "";
		}
		/**
		* Warn if there's no key explicitly set on dynamic arrays of children or
		* object keys are not valid. This allows us to keep track of children between
		* updates.
		*/
		var ownerHasKeyUseWarning = {};
		function getCurrentComponentErrorInfo(parentType) {
			var info = getDeclarationErrorAddendum();
			if (!info) {
				var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
				if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
			}
			return info;
		}
		/**
		* Warn if the element doesn't have an explicit key assigned to it.
		* This element is in an array. The array could grow and shrink or be
		* reordered. All children that haven't already been validated are required to
		* have a "key" property assigned to it. Error statuses are cached so a warning
		* will only be shown once.
		*
		* @internal
		* @param {ReactElement} element Element that requires a key.
		* @param {*} parentType element's parent's type.
		*/
		function validateExplicitKey(element, parentType) {
			if (!element._store || element._store.validated || element.key != null) return;
			element._store.validated = true;
			var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
			if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
			ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
			var childOwner = "";
			if (element && element._owner && element._owner !== ReactCurrentOwner.current) childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
			setCurrentlyValidatingElement$1(element);
			error("Each child in a list should have a unique \"key\" prop.%s%s See https://reactjs.org/link/warning-keys for more information.", currentComponentErrorInfo, childOwner);
			setCurrentlyValidatingElement$1(null);
		}
		/**
		* Ensure that every element either is passed in a static location, in an
		* array with an explicit keys property defined, or in an object literal
		* with valid key property.
		*
		* @internal
		* @param {ReactNode} node Statically passed child of any type.
		* @param {*} parentType node's parent's type.
		*/
		function validateChildKeys(node, parentType) {
			if (typeof node !== "object") return;
			if (isArray(node)) for (var i = 0; i < node.length; i++) {
				var child = node[i];
				if (isValidElement(child)) validateExplicitKey(child, parentType);
			}
			else if (isValidElement(node)) {
				if (node._store) node._store.validated = true;
			} else if (node) {
				var iteratorFn = getIteratorFn(node);
				if (typeof iteratorFn === "function") {
					if (iteratorFn !== node.entries) {
						var iterator = iteratorFn.call(node);
						var step;
						while (!(step = iterator.next()).done) if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
					}
				}
			}
		}
		/**
		* Given an element, validate that its props follow the propTypes definition,
		* provided by the type.
		*
		* @param {ReactElement} element
		*/
		function validatePropTypes(element) {
			var type = element.type;
			if (type === null || type === void 0 || typeof type === "string") return;
			var propTypes;
			if (typeof type === "function") propTypes = type.propTypes;
			else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
			else return;
			if (propTypes) {
				var name = getComponentNameFromType(type);
				checkPropTypes(propTypes, element.props, "prop", name, element);
			} else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
				propTypesMisspellWarningShown = true;
				error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", getComponentNameFromType(type) || "Unknown");
			}
			if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
		}
		/**
		* Given a fragment, validate that it can only be provided with fragment props
		* @param {ReactElement} fragment
		*/
		function validateFragmentProps(fragment) {
			var keys = Object.keys(fragment.props);
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				if (key !== "children" && key !== "key") {
					setCurrentlyValidatingElement$1(fragment);
					error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
					setCurrentlyValidatingElement$1(null);
					break;
				}
			}
			if (fragment.ref !== null) {
				setCurrentlyValidatingElement$1(fragment);
				error("Invalid attribute `ref` supplied to `React.Fragment`.");
				setCurrentlyValidatingElement$1(null);
			}
		}
		function createElementWithValidation(type, props, children) {
			var validType = isValidElementType(type);
			if (!validType) {
				var info = "";
				if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
				var sourceInfo = getSourceInfoErrorAddendumForProps(props);
				if (sourceInfo) info += sourceInfo;
				else info += getDeclarationErrorAddendum();
				var typeString;
				if (type === null) typeString = "null";
				else if (isArray(type)) typeString = "array";
				else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
					typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
					info = " Did you accidentally export a JSX literal instead of a component?";
				} else typeString = typeof type;
				error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
			}
			var element = createElement.apply(this, arguments);
			if (element == null) return element;
			if (validType) for (var i = 2; i < arguments.length; i++) validateChildKeys(arguments[i], type);
			if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
			else validatePropTypes(element);
			return element;
		}
		var didWarnAboutDeprecatedCreateFactory = false;
		function createFactoryWithValidation(type) {
			var validatedFactory = createElementWithValidation.bind(null, type);
			validatedFactory.type = type;
			if (!didWarnAboutDeprecatedCreateFactory) {
				didWarnAboutDeprecatedCreateFactory = true;
				warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
			}
			Object.defineProperty(validatedFactory, "type", {
				enumerable: false,
				get: function() {
					warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
					Object.defineProperty(this, "type", { value: type });
					return type;
				}
			});
			return validatedFactory;
		}
		function cloneElementWithValidation(element, props, children) {
			var newElement = cloneElement.apply(this, arguments);
			for (var i = 2; i < arguments.length; i++) validateChildKeys(arguments[i], newElement.type);
			validatePropTypes(newElement);
			return newElement;
		}
		function startTransition(scope, options) {
			var prevTransition = ReactCurrentBatchConfig.transition;
			ReactCurrentBatchConfig.transition = {};
			var currentTransition = ReactCurrentBatchConfig.transition;
			ReactCurrentBatchConfig.transition._updatedFibers = /* @__PURE__ */ new Set();
			try {
				scope();
			} finally {
				ReactCurrentBatchConfig.transition = prevTransition;
				if (prevTransition === null && currentTransition._updatedFibers) {
					if (currentTransition._updatedFibers.size > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
					currentTransition._updatedFibers.clear();
				}
			}
		}
		var didWarnAboutMessageChannel = false;
		var enqueueTaskImpl = null;
		function enqueueTask(task) {
			if (enqueueTaskImpl === null) try {
				var requireString = ("require" + Math.random()).slice(0, 7);
				enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
			} catch (_err) {
				enqueueTaskImpl = function(callback) {
					if (didWarnAboutMessageChannel === false) {
						didWarnAboutMessageChannel = true;
						if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
					}
					var channel = new MessageChannel();
					channel.port1.onmessage = callback;
					channel.port2.postMessage(void 0);
				};
			}
			return enqueueTaskImpl(task);
		}
		var actScopeDepth = 0;
		var didWarnNoAwaitAct = false;
		function act(callback) {
			var prevActScopeDepth = actScopeDepth;
			actScopeDepth++;
			if (ReactCurrentActQueue.current === null) ReactCurrentActQueue.current = [];
			var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
			var result;
			try {
				ReactCurrentActQueue.isBatchingLegacy = true;
				result = callback();
				if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
					var queue = ReactCurrentActQueue.current;
					if (queue !== null) {
						ReactCurrentActQueue.didScheduleLegacyUpdate = false;
						flushActQueue(queue);
					}
				}
			} catch (error) {
				popActScope(prevActScopeDepth);
				throw error;
			} finally {
				ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
			}
			if (result !== null && typeof result === "object" && typeof result.then === "function") {
				var thenableResult = result;
				var wasAwaited = false;
				var thenable = { then: function(resolve, reject) {
					wasAwaited = true;
					thenableResult.then(function(returnValue) {
						popActScope(prevActScopeDepth);
						if (actScopeDepth === 0) recursivelyFlushAsyncActWork(returnValue, resolve, reject);
						else resolve(returnValue);
					}, function(error) {
						popActScope(prevActScopeDepth);
						reject(error);
					});
				} };
				if (!didWarnNoAwaitAct && typeof Promise !== "undefined") Promise.resolve().then(function() {}).then(function() {
					if (!wasAwaited) {
						didWarnNoAwaitAct = true;
						error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
					}
				});
				return thenable;
			} else {
				var returnValue = result;
				popActScope(prevActScopeDepth);
				if (actScopeDepth === 0) {
					var _queue = ReactCurrentActQueue.current;
					if (_queue !== null) {
						flushActQueue(_queue);
						ReactCurrentActQueue.current = null;
					}
					return { then: function(resolve, reject) {
						if (ReactCurrentActQueue.current === null) {
							ReactCurrentActQueue.current = [];
							recursivelyFlushAsyncActWork(returnValue, resolve, reject);
						} else resolve(returnValue);
					} };
				} else return { then: function(resolve, reject) {
					resolve(returnValue);
				} };
			}
		}
		function popActScope(prevActScopeDepth) {
			if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
			actScopeDepth = prevActScopeDepth;
		}
		function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
			var queue = ReactCurrentActQueue.current;
			if (queue !== null) try {
				flushActQueue(queue);
				enqueueTask(function() {
					if (queue.length === 0) {
						ReactCurrentActQueue.current = null;
						resolve(returnValue);
					} else recursivelyFlushAsyncActWork(returnValue, resolve, reject);
				});
			} catch (error) {
				reject(error);
			}
			else resolve(returnValue);
		}
		var isFlushing = false;
		function flushActQueue(queue) {
			if (!isFlushing) {
				isFlushing = true;
				var i = 0;
				try {
					for (; i < queue.length; i++) {
						var callback = queue[i];
						do
							callback = callback(true);
						while (callback !== null);
					}
					queue.length = 0;
				} catch (error) {
					queue = queue.slice(i + 1);
					throw error;
				} finally {
					isFlushing = false;
				}
			}
		}
		var createElement$1 = createElementWithValidation;
		var cloneElement$1 = cloneElementWithValidation;
		var createFactory = createFactoryWithValidation;
		exports.Children = {
			map: mapChildren,
			forEach: forEachChildren,
			count: countChildren,
			toArray,
			only: onlyChild
		};
		exports.Component = Component;
		exports.Fragment = REACT_FRAGMENT_TYPE;
		exports.Profiler = REACT_PROFILER_TYPE;
		exports.PureComponent = PureComponent;
		exports.StrictMode = REACT_STRICT_MODE_TYPE;
		exports.Suspense = REACT_SUSPENSE_TYPE;
		exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
		exports.act = act;
		exports.cloneElement = cloneElement$1;
		exports.createContext = createContext;
		exports.createElement = createElement$1;
		exports.createFactory = createFactory;
		exports.createRef = createRef;
		exports.forwardRef = forwardRef;
		exports.isValidElement = isValidElement;
		exports.lazy = lazy;
		exports.memo = memo;
		exports.startTransition = startTransition;
		exports.unstable_act = act;
		exports.useCallback = useCallback;
		exports.useContext = useContext;
		exports.useDebugValue = useDebugValue;
		exports.useDeferredValue = useDeferredValue;
		exports.useEffect = useEffect;
		exports.useId = useId;
		exports.useImperativeHandle = useImperativeHandle;
		exports.useInsertionEffect = useInsertionEffect;
		exports.useLayoutEffect = useLayoutEffect;
		exports.useMemo = useMemo;
		exports.useReducer = useReducer;
		exports.useRef = useRef;
		exports.useState = useState;
		exports.useSyncExternalStore = useSyncExternalStore;
		exports.useTransition = useTransition;
		exports.version = ReactVersion;
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ new Error());
	})();
}));
//#endregion
//#region ../../node_modules/react/index.js
var require_react = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_production_min();
	else module.exports = require_react_development();
}));
//#endregion
//#region ../../node_modules/react-is/cjs/react-is.production.min.js
/** @license React v16.13.1
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_is_production_min = /* @__PURE__ */ __commonJSMin(((exports) => {
	var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
	function z(a) {
		if ("object" === typeof a && null !== a) {
			var u = a.$$typeof;
			switch (u) {
				case c: switch (a = a.type, a) {
					case l:
					case m:
					case e:
					case g:
					case f:
					case p: return a;
					default: switch (a = a && a.$$typeof, a) {
						case k:
						case n:
						case t:
						case r:
						case h: return a;
						default: return u;
					}
				}
				case d: return u;
			}
		}
	}
	function A(a) {
		return z(a) === m;
	}
	exports.AsyncMode = l;
	exports.ConcurrentMode = m;
	exports.ContextConsumer = k;
	exports.ContextProvider = h;
	exports.Element = c;
	exports.ForwardRef = n;
	exports.Fragment = e;
	exports.Lazy = t;
	exports.Memo = r;
	exports.Portal = d;
	exports.Profiler = g;
	exports.StrictMode = f;
	exports.Suspense = p;
	exports.isAsyncMode = function(a) {
		return A(a) || z(a) === l;
	};
	exports.isConcurrentMode = A;
	exports.isContextConsumer = function(a) {
		return z(a) === k;
	};
	exports.isContextProvider = function(a) {
		return z(a) === h;
	};
	exports.isElement = function(a) {
		return "object" === typeof a && null !== a && a.$$typeof === c;
	};
	exports.isForwardRef = function(a) {
		return z(a) === n;
	};
	exports.isFragment = function(a) {
		return z(a) === e;
	};
	exports.isLazy = function(a) {
		return z(a) === t;
	};
	exports.isMemo = function(a) {
		return z(a) === r;
	};
	exports.isPortal = function(a) {
		return z(a) === d;
	};
	exports.isProfiler = function(a) {
		return z(a) === g;
	};
	exports.isStrictMode = function(a) {
		return z(a) === f;
	};
	exports.isSuspense = function(a) {
		return z(a) === p;
	};
	exports.isValidElementType = function(a) {
		return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};
	exports.typeOf = z;
}));
//#endregion
//#region ../../node_modules/react-is/cjs/react-is.development.js
/** @license React v16.13.1
* react-is.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_is_development = /* @__PURE__ */ __commonJSMin(((exports) => {
	if (process.env.NODE_ENV !== "production") (function() {
		"use strict";
		var hasSymbol = typeof Symbol === "function" && Symbol.for;
		var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
		var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
		var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
		var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
		var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
		var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
		var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
		var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
		var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
		var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
		var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
		var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
		var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
		var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
		var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
		var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
		var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
		var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
		function isValidElementType(type) {
			return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
		}
		function typeOf(object) {
			if (typeof object === "object" && object !== null) {
				var $$typeof = object.$$typeof;
				switch ($$typeof) {
					case REACT_ELEMENT_TYPE:
						var type = object.type;
						switch (type) {
							case REACT_ASYNC_MODE_TYPE:
							case REACT_CONCURRENT_MODE_TYPE:
							case REACT_FRAGMENT_TYPE:
							case REACT_PROFILER_TYPE:
							case REACT_STRICT_MODE_TYPE:
							case REACT_SUSPENSE_TYPE: return type;
							default:
								var $$typeofType = type && type.$$typeof;
								switch ($$typeofType) {
									case REACT_CONTEXT_TYPE:
									case REACT_FORWARD_REF_TYPE:
									case REACT_LAZY_TYPE:
									case REACT_MEMO_TYPE:
									case REACT_PROVIDER_TYPE: return $$typeofType;
									default: return $$typeof;
								}
						}
					case REACT_PORTAL_TYPE: return $$typeof;
				}
			}
		}
		var AsyncMode = REACT_ASYNC_MODE_TYPE;
		var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
		var ContextConsumer = REACT_CONTEXT_TYPE;
		var ContextProvider = REACT_PROVIDER_TYPE;
		var Element = REACT_ELEMENT_TYPE;
		var ForwardRef = REACT_FORWARD_REF_TYPE;
		var Fragment = REACT_FRAGMENT_TYPE;
		var Lazy = REACT_LAZY_TYPE;
		var Memo = REACT_MEMO_TYPE;
		var Portal = REACT_PORTAL_TYPE;
		var Profiler = REACT_PROFILER_TYPE;
		var StrictMode = REACT_STRICT_MODE_TYPE;
		var Suspense = REACT_SUSPENSE_TYPE;
		var hasWarnedAboutDeprecatedIsAsyncMode = false;
		function isAsyncMode(object) {
			if (!hasWarnedAboutDeprecatedIsAsyncMode) {
				hasWarnedAboutDeprecatedIsAsyncMode = true;
				console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
			}
			return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
		}
		function isConcurrentMode(object) {
			return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
		}
		function isContextConsumer(object) {
			return typeOf(object) === REACT_CONTEXT_TYPE;
		}
		function isContextProvider(object) {
			return typeOf(object) === REACT_PROVIDER_TYPE;
		}
		function isElement(object) {
			return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		}
		function isForwardRef(object) {
			return typeOf(object) === REACT_FORWARD_REF_TYPE;
		}
		function isFragment(object) {
			return typeOf(object) === REACT_FRAGMENT_TYPE;
		}
		function isLazy(object) {
			return typeOf(object) === REACT_LAZY_TYPE;
		}
		function isMemo(object) {
			return typeOf(object) === REACT_MEMO_TYPE;
		}
		function isPortal(object) {
			return typeOf(object) === REACT_PORTAL_TYPE;
		}
		function isProfiler(object) {
			return typeOf(object) === REACT_PROFILER_TYPE;
		}
		function isStrictMode(object) {
			return typeOf(object) === REACT_STRICT_MODE_TYPE;
		}
		function isSuspense(object) {
			return typeOf(object) === REACT_SUSPENSE_TYPE;
		}
		exports.AsyncMode = AsyncMode;
		exports.ConcurrentMode = ConcurrentMode;
		exports.ContextConsumer = ContextConsumer;
		exports.ContextProvider = ContextProvider;
		exports.Element = Element;
		exports.ForwardRef = ForwardRef;
		exports.Fragment = Fragment;
		exports.Lazy = Lazy;
		exports.Memo = Memo;
		exports.Portal = Portal;
		exports.Profiler = Profiler;
		exports.StrictMode = StrictMode;
		exports.Suspense = Suspense;
		exports.isAsyncMode = isAsyncMode;
		exports.isConcurrentMode = isConcurrentMode;
		exports.isContextConsumer = isContextConsumer;
		exports.isContextProvider = isContextProvider;
		exports.isElement = isElement;
		exports.isForwardRef = isForwardRef;
		exports.isFragment = isFragment;
		exports.isLazy = isLazy;
		exports.isMemo = isMemo;
		exports.isPortal = isPortal;
		exports.isProfiler = isProfiler;
		exports.isStrictMode = isStrictMode;
		exports.isSuspense = isSuspense;
		exports.isValidElementType = isValidElementType;
		exports.typeOf = typeOf;
	})();
}));
//#endregion
//#region ../../node_modules/react-is/index.js
var require_react_is = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_is_production_min();
	else module.exports = require_react_is_development();
}));
//#endregion
//#region ../../node_modules/object-assign/index.js
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var require_object_assign = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	function toObject(val) {
		if (val === null || val === void 0) throw new TypeError("Object.assign cannot be called with null or undefined");
		return Object(val);
	}
	function shouldUseNative() {
		try {
			if (!Object.assign) return false;
			var test1 = /* @__PURE__ */ new String("abc");
			test1[5] = "de";
			if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
			var test2 = {};
			for (var i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
			if (Object.getOwnPropertyNames(test2).map(function(n) {
				return test2[n];
			}).join("") !== "0123456789") return false;
			var test3 = {};
			"abcdefghijklmnopqrst".split("").forEach(function(letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
			return true;
		} catch (err) {
			return false;
		}
	}
	module.exports = shouldUseNative() ? Object.assign : function(target, source) {
		var from;
		var to = toObject(target);
		var symbols;
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
			for (var key in from) if (hasOwnProperty.call(from, key)) to[key] = from[key];
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
			}
		}
		return to;
	};
}));
//#endregion
//#region ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_ReactPropTypesSecret = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}));
//#endregion
//#region ../../node_modules/prop-types/lib/has.js
var require_has = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
}));
//#endregion
//#region ../../node_modules/prop-types/checkPropTypes.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_checkPropTypes = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var printWarning = function() {};
	if (process.env.NODE_ENV !== "production") {
		var ReactPropTypesSecret = require_ReactPropTypesSecret();
		var loggedTypeFailures = {};
		var has = require_has();
		printWarning = function(text) {
			var message = "Warning: " + text;
			if (typeof console !== "undefined") console.error(message);
			try {
				throw new Error(message);
			} catch (x) {}
		};
	}
	/**
	* Assert that the values match with the type specs.
	* Error messages are memorized and will only be shown once.
	*
	* @param {object} typeSpecs Map of name to a ReactPropType
	* @param {object} values Runtime values that need to be type-checked
	* @param {string} location e.g. "prop", "context", "child context"
	* @param {string} componentName Name of the component for error messages.
	* @param {?Function} getStack Returns the component stack.
	* @private
	*/
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		if (process.env.NODE_ENV !== "production") {
			for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
				var error;
				try {
					if (typeof typeSpecs[typeSpecName] !== "function") {
						var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						err.name = "Invariant Violation";
						throw err;
					}
					error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
				} catch (ex) {
					error = ex;
				}
				if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
				if (error instanceof Error && !(error.message in loggedTypeFailures)) {
					loggedTypeFailures[error.message] = true;
					var stack = getStack ? getStack() : "";
					printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
				}
			}
		}
	}
	/**
	* Resets warning cache when testing.
	*
	* @private
	*/
	checkPropTypes.resetWarningCache = function() {
		if (process.env.NODE_ENV !== "production") loggedTypeFailures = {};
	};
	module.exports = checkPropTypes;
}));
//#endregion
//#region ../../node_modules/prop-types/factoryWithTypeCheckers.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_factoryWithTypeCheckers = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ReactIs = require_react_is();
	var assign = require_object_assign();
	var ReactPropTypesSecret = require_ReactPropTypesSecret();
	var has = require_has();
	var checkPropTypes = require_checkPropTypes();
	var printWarning = function() {};
	if (process.env.NODE_ENV !== "production") printWarning = function(text) {
		var message = "Warning: " + text;
		if (typeof console !== "undefined") console.error(message);
		try {
			throw new Error(message);
		} catch (x) {}
	};
	function emptyFunctionThatReturnsNull() {
		return null;
	}
	module.exports = function(isValidElement, throwOnDirectAccess) {
		var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = "@@iterator";
		/**
		* Returns the iterator method function contained on the iterable object.
		*
		* Be sure to invoke the function with the iterable as context:
		*
		*     var iteratorFn = getIteratorFn(myIterable);
		*     if (iteratorFn) {
		*       var iterator = iteratorFn.call(myIterable);
		*       ...
		*     }
		*
		* @param {?object} maybeIterable
		* @return {?function}
		*/
		function getIteratorFn(maybeIterable) {
			var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			if (typeof iteratorFn === "function") return iteratorFn;
		}
		/**
		* Collection of methods that allow declaration and validation of props that are
		* supplied to React components. Example usage:
		*
		*   var Props = require('ReactPropTypes');
		*   var MyArticle = React.createClass({
		*     propTypes: {
		*       // An optional string prop named "description".
		*       description: Props.string,
		*
		*       // A required enum prop named "category".
		*       category: Props.oneOf(['News','Photos']).isRequired,
		*
		*       // A prop named "dialog" that requires an instance of Dialog.
		*       dialog: Props.instanceOf(Dialog).isRequired
		*     },
		*     render: function() { ... }
		*   });
		*
		* A more formal specification of how these methods are used:
		*
		*   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		*   decl := ReactPropTypes.{type}(.isRequired)?
		*
		* Each and every declaration produces a function with the same signature. This
		* allows the creation of custom validation functions. For example:
		*
		*  var MyLink = React.createClass({
		*    propTypes: {
		*      // An optional string or URI prop named "href".
		*      href: function(props, propName, componentName) {
		*        var propValue = props[propName];
		*        if (propValue != null && typeof propValue !== 'string' &&
		*            !(propValue instanceof URI)) {
		*          return new Error(
		*            'Expected a string or an URI for ' + propName + ' in ' +
		*            componentName
		*          );
		*        }
		*      }
		*    },
		*    render: function() {...}
		*  });
		*
		* @internal
		*/
		var ANONYMOUS = "<<anonymous>>";
		var ReactPropTypes = {
			array: createPrimitiveTypeChecker("array"),
			bigint: createPrimitiveTypeChecker("bigint"),
			bool: createPrimitiveTypeChecker("boolean"),
			func: createPrimitiveTypeChecker("function"),
			number: createPrimitiveTypeChecker("number"),
			object: createPrimitiveTypeChecker("object"),
			string: createPrimitiveTypeChecker("string"),
			symbol: createPrimitiveTypeChecker("symbol"),
			any: createAnyTypeChecker(),
			arrayOf: createArrayOfTypeChecker,
			element: createElementTypeChecker(),
			elementType: createElementTypeTypeChecker(),
			instanceOf: createInstanceTypeChecker,
			node: createNodeChecker(),
			objectOf: createObjectOfTypeChecker,
			oneOf: createEnumTypeChecker,
			oneOfType: createUnionTypeChecker,
			shape: createShapeTypeChecker,
			exact: createStrictShapeTypeChecker
		};
		/**
		* inlined Object.is polyfill to avoid requiring consumers ship their own
		* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		*/
		function is(x, y) {
			if (x === y) return x !== 0 || 1 / x === 1 / y;
			else return x !== x && y !== y;
		}
		/**
		* We use an Error-like object for backward compatibility as people may call
		* PropTypes directly and inspect their output. However, we don't use real
		* Errors anymore. We don't inspect their stack anyway, and creating them
		* is prohibitively expensive if they are created too often, such as what
		* happens in oneOfType() for any type before the one that matched.
		*/
		function PropTypeError(message, data) {
			this.message = message;
			this.data = data && typeof data === "object" ? data : {};
			this.stack = "";
		}
		PropTypeError.prototype = Error.prototype;
		function createChainableTypeChecker(validate) {
			if (process.env.NODE_ENV !== "production") {
				var manualPropTypeCallCache = {};
				var manualPropTypeWarningCount = 0;
			}
			function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
				componentName = componentName || ANONYMOUS;
				propFullName = propFullName || propName;
				if (secret !== ReactPropTypesSecret) {
					if (throwOnDirectAccess) {
						var err = /* @__PURE__ */ new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						err.name = "Invariant Violation";
						throw err;
					} else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
						var cacheKey = componentName + ":" + propName;
						if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
							printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
							manualPropTypeCallCache[cacheKey] = true;
							manualPropTypeWarningCount++;
						}
					}
				}
				if (props[propName] == null) {
					if (isRequired) {
						if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
						return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
					}
					return null;
				} else return validate(props, propName, componentName, location, propFullName);
			}
			var chainedCheckType = checkType.bind(null, false);
			chainedCheckType.isRequired = checkType.bind(null, true);
			return chainedCheckType;
		}
		function createPrimitiveTypeChecker(expectedType) {
			function validate(props, propName, componentName, location, propFullName, secret) {
				var propValue = props[propName];
				if (getPropType(propValue) !== expectedType) {
					var preciseType = getPreciseType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), { expectedType });
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createAnyTypeChecker() {
			return createChainableTypeChecker(emptyFunctionThatReturnsNull);
		}
		function createArrayOfTypeChecker(typeChecker) {
			function validate(props, propName, componentName, location, propFullName) {
				if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
				var propValue = props[propName];
				if (!Array.isArray(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
				}
				for (var i = 0; i < propValue.length; i++) {
					var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
					if (error instanceof Error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createElementTypeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				if (!isValidElement(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createElementTypeTypeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				if (!ReactIs.isValidElementType(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createInstanceTypeChecker(expectedClass) {
			function validate(props, propName, componentName, location, propFullName) {
				if (!(props[propName] instanceof expectedClass)) {
					var expectedClassName = expectedClass.name || ANONYMOUS;
					var actualClassName = getClassName(props[propName]);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createEnumTypeChecker(expectedValues) {
			if (!Array.isArray(expectedValues)) {
				if (process.env.NODE_ENV !== "production") if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
				else printWarning("Invalid argument supplied to oneOf, expected an array.");
				return emptyFunctionThatReturnsNull;
			}
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				for (var i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
				var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
					if (getPreciseType(value) === "symbol") return String(value);
					return value;
				});
				return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
			}
			return createChainableTypeChecker(validate);
		}
		function createObjectOfTypeChecker(typeChecker) {
			function validate(props, propName, componentName, location, propFullName) {
				if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
				for (var key in propValue) if (has(propValue, key)) {
					var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error instanceof Error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createUnionTypeChecker(arrayOfTypeCheckers) {
			if (!Array.isArray(arrayOfTypeCheckers)) {
				process.env.NODE_ENV !== "production" && printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
				return emptyFunctionThatReturnsNull;
			}
			for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
				var checker = arrayOfTypeCheckers[i];
				if (typeof checker !== "function") {
					printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
					return emptyFunctionThatReturnsNull;
				}
			}
			function validate(props, propName, componentName, location, propFullName) {
				var expectedTypes = [];
				for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
					var checker = arrayOfTypeCheckers[i];
					var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
					if (checkerResult == null) return null;
					if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
				}
				var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
				return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
			}
			return createChainableTypeChecker(validate);
		}
		function createNodeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function invalidValidatorError(componentName, location, propFullName, key, type) {
			return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
		}
		function createShapeTypeChecker(shapeTypes) {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
				for (var key in shapeTypes) {
					var checker = shapeTypes[key];
					if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
					var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createStrictShapeTypeChecker(shapeTypes) {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
				for (var key in assign({}, props[propName], shapeTypes)) {
					var checker = shapeTypes[key];
					if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
					if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
					var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function isNode(propValue) {
			switch (typeof propValue) {
				case "number":
				case "string":
				case "undefined": return true;
				case "boolean": return !propValue;
				case "object":
					if (Array.isArray(propValue)) return propValue.every(isNode);
					if (propValue === null || isValidElement(propValue)) return true;
					var iteratorFn = getIteratorFn(propValue);
					if (iteratorFn) {
						var iterator = iteratorFn.call(propValue);
						var step;
						if (iteratorFn !== propValue.entries) {
							while (!(step = iterator.next()).done) if (!isNode(step.value)) return false;
						} else while (!(step = iterator.next()).done) {
							var entry = step.value;
							if (entry) {
								if (!isNode(entry[1])) return false;
							}
						}
					} else return false;
					return true;
				default: return false;
			}
		}
		function isSymbol(propType, propValue) {
			if (propType === "symbol") return true;
			if (!propValue) return false;
			if (propValue["@@toStringTag"] === "Symbol") return true;
			if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
			return false;
		}
		function getPropType(propValue) {
			var propType = typeof propValue;
			if (Array.isArray(propValue)) return "array";
			if (propValue instanceof RegExp) return "object";
			if (isSymbol(propType, propValue)) return "symbol";
			return propType;
		}
		function getPreciseType(propValue) {
			if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
			var propType = getPropType(propValue);
			if (propType === "object") {
				if (propValue instanceof Date) return "date";
				else if (propValue instanceof RegExp) return "regexp";
			}
			return propType;
		}
		function getPostfixForTypeWarning(value) {
			var type = getPreciseType(value);
			switch (type) {
				case "array":
				case "object": return "an " + type;
				case "boolean":
				case "date":
				case "regexp": return "a " + type;
				default: return type;
			}
		}
		function getClassName(propValue) {
			if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
			return propValue.constructor.name;
		}
		ReactPropTypes.checkPropTypes = checkPropTypes;
		ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
		ReactPropTypes.PropTypes = ReactPropTypes;
		return ReactPropTypes;
	};
}));
//#endregion
//#region ../../node_modules/prop-types/factoryWithThrowingShims.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_factoryWithThrowingShims = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ReactPropTypesSecret = require_ReactPropTypesSecret();
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	module.exports = function() {
		function shim(props, propName, componentName, location, propFullName, secret) {
			if (secret === ReactPropTypesSecret) return;
			var err = /* @__PURE__ */ new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
			err.name = "Invariant Violation";
			throw err;
		}
		shim.isRequired = shim;
		function getShim() {
			return shim;
		}
		var ReactPropTypes = {
			array: shim,
			bigint: shim,
			bool: shim,
			func: shim,
			number: shim,
			object: shim,
			string: shim,
			symbol: shim,
			any: shim,
			arrayOf: getShim,
			element: shim,
			elementType: shim,
			instanceOf: getShim,
			node: shim,
			objectOf: getShim,
			oneOf: getShim,
			oneOfType: getShim,
			shape: getShim,
			exact: getShim,
			checkPropTypes: emptyFunctionWithReset,
			resetWarningCache: emptyFunction
		};
		ReactPropTypes.PropTypes = ReactPropTypes;
		return ReactPropTypes;
	};
}));
//#endregion
//#region ../../node_modules/prop-types/index.js
var require_prop_types = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright (c) 2013-present, Facebook, Inc.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	if (process.env.NODE_ENV !== "production") {
		var ReactIs = require_react_is();
		module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, true);
	} else module.exports = require_factoryWithThrowingShims()();
}));
(/* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function webpackUniversalModuleDefinition(root, factory) {
		if (typeof exports === "object" && typeof module === "object") module.exports = factory(require_react(), require_prop_types());
		else if (typeof define === "function" && define.amd) define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === "object" ? factory(require_react(), require_prop_types()) : factory(root["react"], root["prop-types"]);
			for (var i in a) (typeof exports === "object" ? exports : root)[i] = a[i];
		}
	})(typeof self !== "undefined" ? self : exports, function(__WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
		return (function(modules) {
			var installedModules = {};
			function __webpack_require__(moduleId) {
				if (installedModules[moduleId]) return installedModules[moduleId].exports;
				var module$1 = installedModules[moduleId] = {
					i: moduleId,
					l: false,
					exports: {}
				};
				modules[moduleId].call(module$1.exports, module$1, module$1.exports, __webpack_require__);
				module$1.l = true;
				return module$1.exports;
			}
			__webpack_require__.m = modules;
			__webpack_require__.c = installedModules;
			__webpack_require__.d = function(exports$1, name, getter) {
				if (!__webpack_require__.o(exports$1, name)) Object.defineProperty(exports$1, name, {
					enumerable: true,
					get: getter
				});
			};
			__webpack_require__.r = function(exports$2) {
				if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(exports$2, Symbol.toStringTag, { value: "Module" });
				Object.defineProperty(exports$2, "__esModule", { value: true });
			};
			__webpack_require__.t = function(value, mode) {
				if (mode & 1) value = __webpack_require__(value);
				if (mode & 8) return value;
				if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
				var ns = Object.create(null);
				__webpack_require__.r(ns);
				Object.defineProperty(ns, "default", {
					enumerable: true,
					value
				});
				if (mode & 2 && typeof value != "string") for (var key in value) __webpack_require__.d(ns, key, function(key) {
					return value[key];
				}.bind(null, key));
				return ns;
			};
			__webpack_require__.n = function(module$2) {
				var getter = module$2 && module$2.__esModule ? function getDefault() {
					return module$2["default"];
				} : function getModuleExports() {
					return module$2;
				};
				__webpack_require__.d(getter, "a", getter);
				return getter;
			};
			__webpack_require__.o = function(object, property) {
				return Object.prototype.hasOwnProperty.call(object, property);
			};
			__webpack_require__.p = "";
			return __webpack_require__(__webpack_require__.s = 11);
		})([
			(function(module$3, exports$3, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$3, "__esModule", { value: true });
				exports$3["default"] = warn;
				function warn(s) {
					console.warn("[react-ga]", s);
				}
			}),
			(function(module$4, exports$4, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$4, "__esModule", { value: true });
				exports$4["default"] = trim;
				function trim(s) {
					return s && s.toString().replace(/^\s+|\s+$/g, "");
				}
			}),
			(function(module$5, exports$5, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$5, "__esModule", { value: true });
				exports$5.addTrackers = addTrackers;
				exports$5["default"] = void 0;
				exports$5.event = event;
				exports$5.exception = exception;
				exports$5.ga = ga;
				exports$5.initialize = initialize;
				exports$5.modalview = modalview;
				exports$5.outboundLink = outboundLink;
				exports$5.pageview = pageview;
				exports$5.plugin = void 0;
				exports$5.send = send;
				exports$5.set = set;
				exports$5.testModeAPI = void 0;
				exports$5.timing = timing;
				var _format2 = _interopRequireDefault(__webpack_require__(3));
				var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(7));
				var _trim = _interopRequireDefault(__webpack_require__(1));
				var _loadGA = _interopRequireDefault(__webpack_require__(8));
				var _warn = _interopRequireDefault(__webpack_require__(0));
				var _log = _interopRequireDefault(__webpack_require__(9));
				var _testModeAPI = _interopRequireDefault(__webpack_require__(10));
				var _excluded = [
					"category",
					"action",
					"label",
					"value",
					"nonInteraction",
					"transport"
				];
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				function _objectWithoutProperties(source, excluded) {
					if (source == null) return {};
					var target = _objectWithoutPropertiesLoose(source, excluded);
					var key, i;
					if (Object.getOwnPropertySymbols) {
						var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
						for (i = 0; i < sourceSymbolKeys.length; i++) {
							key = sourceSymbolKeys[i];
							if (excluded.indexOf(key) >= 0) continue;
							if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
							target[key] = source[key];
						}
					}
					return target;
				}
				function _objectWithoutPropertiesLoose(source, excluded) {
					if (source == null) return {};
					var target = {};
					var sourceKeys = Object.keys(source);
					var key, i;
					for (i = 0; i < sourceKeys.length; i++) {
						key = sourceKeys[i];
						if (excluded.indexOf(key) >= 0) continue;
						target[key] = source[key];
					}
					return target;
				}
				function ownKeys(object, enumerableOnly) {
					var keys = Object.keys(object);
					if (Object.getOwnPropertySymbols) {
						var symbols = Object.getOwnPropertySymbols(object);
						enumerableOnly && (symbols = symbols.filter(function(sym) {
							return Object.getOwnPropertyDescriptor(object, sym).enumerable;
						})), keys.push.apply(keys, symbols);
					}
					return keys;
				}
				function _objectSpread(target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = null != arguments[i] ? arguments[i] : {};
						i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
							_defineProperty(target, key, source[key]);
						}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
							Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
						});
					}
					return target;
				}
				function _defineProperty(obj, key, value) {
					if (key in obj) Object.defineProperty(obj, key, {
						value,
						enumerable: true,
						configurable: true,
						writable: true
					});
					else obj[key] = value;
					return obj;
				}
				function _typeof(obj) {
					"@babel/helpers - typeof";
					return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
						return typeof obj;
					} : function(obj) {
						return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
					}, _typeof(obj);
				}
				function _toConsumableArray(arr) {
					return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
				}
				function _nonIterableSpread() {
					throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
				}
				function _unsupportedIterableToArray(o, minLen) {
					if (!o) return;
					if (typeof o === "string") return _arrayLikeToArray(o, minLen);
					var n = Object.prototype.toString.call(o).slice(8, -1);
					if (n === "Object" && o.constructor) n = o.constructor.name;
					if (n === "Map" || n === "Set") return Array.from(o);
					if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
				}
				function _iterableToArray(iter) {
					if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
				}
				function _arrayWithoutHoles(arr) {
					if (Array.isArray(arr)) return _arrayLikeToArray(arr);
				}
				function _arrayLikeToArray(arr, len) {
					if (len == null || len > arr.length) len = arr.length;
					for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
					return arr2;
				}
				var _isNotBrowser = typeof window === "undefined" || typeof document === "undefined";
				var _debug = false;
				var _titleCase = true;
				var _testMode = false;
				var _alwaysSendToDefaultTracker = true;
				var _redactEmail = true;
				var internalGa = function internalGa() {
					var _window;
					if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
					if (_isNotBrowser) return false;
					if (!window.ga) return (0, _warn["default"])("ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually");
					return (_window = window).ga.apply(_window, arguments);
				};
				function _format(s) {
					return (0, _format2["default"])(s, _titleCase, _redactEmail);
				}
				function _gaCommand(trackerNames) {
					for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
					var command = args[0];
					if (typeof internalGa === "function") {
						if (typeof command !== "string") {
							(0, _warn["default"])("ga command must be a string");
							return;
						}
						if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
						if (Array.isArray(trackerNames)) trackerNames.forEach(function(name) {
							internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
						});
					}
				}
				function _initialize(gaTrackingID, options) {
					if (!gaTrackingID) {
						(0, _warn["default"])("gaTrackingID is required in initialize()");
						return;
					}
					if (options) {
						if (options.debug && options.debug === true) _debug = true;
						if (options.titleCase === false) _titleCase = false;
						if (options.redactEmail === false) _redactEmail = false;
						if (options.useExistingGa) return;
					}
					if (options && options.gaOptions) internalGa("create", gaTrackingID, options.gaOptions);
					else internalGa("create", gaTrackingID, "auto");
				}
				function addTrackers(configsOrTrackingId, options) {
					if (Array.isArray(configsOrTrackingId)) configsOrTrackingId.forEach(function(config) {
						if (_typeof(config) !== "object") {
							(0, _warn["default"])("All configs must be an object");
							return;
						}
						_initialize(config.trackingId, config);
					});
					else _initialize(configsOrTrackingId, options);
					return true;
				}
				function initialize(configsOrTrackingId, options) {
					if (options && options.testMode === true) _testMode = true;
					else {
						if (_isNotBrowser) return;
						if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
					}
					_alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === "boolean" ? options.alwaysSendToDefaultTracker : true;
					addTrackers(configsOrTrackingId, options);
				}
				/**
				* ga:
				* Returns the original GA object.
				*/
				function ga() {
					for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
					if (args.length > 0) {
						internalGa.apply(void 0, args);
						if (_debug) {
							(0, _log["default"])("called ga('arguments');");
							(0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
						}
					}
					return window.ga;
				}
				/**
				* set:
				* GA tracker set method
				* @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function set(fieldsObject, trackerNames) {
					if (!fieldsObject) {
						(0, _warn["default"])("`fieldsObject` is required in .set()");
						return;
					}
					if (_typeof(fieldsObject) !== "object") {
						(0, _warn["default"])("Expected `fieldsObject` arg to be an Object");
						return;
					}
					if (Object.keys(fieldsObject).length === 0) (0, _warn["default"])("empty `fieldsObject` given to .set()");
					_gaCommand(trackerNames, "set", fieldsObject);
					if (_debug) {
						(0, _log["default"])("called ga('set', fieldsObject);");
						(0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
					}
				}
				/**
				* send:
				* Clone of the low level `ga.send` method
				* WARNING: No validations will be applied to this
				* @param  {Object} fieldObject - field object for tracking different analytics
				* @param  {Array} trackerNames - trackers to send the command to
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function send(fieldObject, trackerNames) {
					_gaCommand(trackerNames, "send", fieldObject);
					if (_debug) {
						(0, _log["default"])("called ga('send', fieldObject);");
						(0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
						(0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
					}
				}
				/**
				* pageview:
				* Basic GA pageview tracking
				* @param  {String} path - the current page page e.g. '/about'
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				* @param {String} title - (optional) the page title e. g. 'My Website'
				*/
				function pageview(rawPath, trackerNames, title) {
					if (!rawPath) {
						(0, _warn["default"])("path is required in .pageview()");
						return;
					}
					var path = (0, _trim["default"])(rawPath);
					if (path === "") {
						(0, _warn["default"])("path cannot be an empty string in .pageview()");
						return;
					}
					var extraFields = {};
					if (title) extraFields.title = title;
					if (typeof ga === "function") {
						_gaCommand(trackerNames, "send", _objectSpread({
							hitType: "pageview",
							page: path
						}, extraFields));
						if (_debug) {
							(0, _log["default"])("called ga('send', 'pageview', path);");
							var extraLog = "";
							if (title) extraLog = " and title: ".concat(title);
							(0, _log["default"])("with path: ".concat(path).concat(extraLog));
						}
					}
				}
				/**
				* modalview:
				* a proxy to basic GA pageview tracking to consistently track
				* modal views that are an equivalent UX to a traditional pageview
				* @param  {String} modalName e.g. 'add-or-edit-club'
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function modalview(rawModalName, trackerNames) {
					if (!rawModalName) {
						(0, _warn["default"])("modalName is required in .modalview(modalName)");
						return;
					}
					var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
					if (modalName === "") {
						(0, _warn["default"])("modalName cannot be an empty string or a single / in .modalview()");
						return;
					}
					if (typeof ga === "function") {
						var path = "/modal/".concat(modalName);
						_gaCommand(trackerNames, "send", "pageview", path);
						if (_debug) {
							(0, _log["default"])("called ga('send', 'pageview', path);");
							(0, _log["default"])("with path: ".concat(path));
						}
					}
				}
				/**
				* timing:
				* GA timing
				* @param args.category {String} required
				* @param args.variable {String} required
				* @param args.value  {Int}  required
				* @param args.label  {String} required
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function timing() {
					var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, category = _ref.category, variable = _ref.variable, value = _ref.value, label = _ref.label;
					var trackerNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
					if (typeof ga === "function") {
						if (!category || !variable || typeof value !== "number") {
							(0, _warn["default"])("args.category, args.variable AND args.value are required in timing() AND args.value has to be a number");
							return;
						}
						var fieldObject = {
							hitType: "timing",
							timingCategory: _format(category),
							timingVar: _format(variable),
							timingValue: value
						};
						if (label) fieldObject.timingLabel = _format(label);
						send(fieldObject, trackerNames);
					}
				}
				/**
				* event:
				* GA event tracking
				* @param args.category {String} required
				* @param args.action {String} required
				* @param args.label {String} optional
				* @param args.value {Int} optional
				* @param args.nonInteraction {boolean} optional
				* @param args.transport {string} optional
				* @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function event() {
					var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, category = _ref2.category, action = _ref2.action, label = _ref2.label, value = _ref2.value, nonInteraction = _ref2.nonInteraction, transport = _ref2.transport, args = _objectWithoutProperties(_ref2, _excluded);
					var trackerNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
					if (typeof ga === "function") {
						if (!category || !action) {
							(0, _warn["default"])("args.category AND args.action are required in event()");
							return;
						}
						var fieldObject = {
							hitType: "event",
							eventCategory: _format(category),
							eventAction: _format(action)
						};
						if (label) fieldObject.eventLabel = _format(label);
						if (typeof value !== "undefined") if (typeof value !== "number") (0, _warn["default"])("Expected `args.value` arg to be a Number.");
						else fieldObject.eventValue = value;
						if (typeof nonInteraction !== "undefined") if (typeof nonInteraction !== "boolean") (0, _warn["default"])("`args.nonInteraction` must be a boolean.");
						else fieldObject.nonInteraction = nonInteraction;
						if (typeof transport !== "undefined") if (typeof transport !== "string") (0, _warn["default"])("`args.transport` must be a string.");
						else {
							if ([
								"beacon",
								"xhr",
								"image"
							].indexOf(transport) === -1) (0, _warn["default"])("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
							fieldObject.transport = transport;
						}
						Object.keys(args).filter(function(key) {
							return key.substr(0, 9) === "dimension";
						}).forEach(function(key) {
							fieldObject[key] = args[key];
						});
						Object.keys(args).filter(function(key) {
							return key.substr(0, 6) === "metric";
						}).forEach(function(key) {
							fieldObject[key] = args[key];
						});
						send(fieldObject, trackerNames);
					}
				}
				/**
				* exception:
				* GA exception tracking
				* @param args.description {String} optional
				* @param args.fatal {boolean} optional
				* @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
				*/
				function exception(_ref3, trackerNames) {
					var description = _ref3.description, fatal = _ref3.fatal;
					if (typeof ga === "function") {
						var fieldObject = { hitType: "exception" };
						if (description) fieldObject.exDescription = _format(description);
						if (typeof fatal !== "undefined") if (typeof fatal !== "boolean") (0, _warn["default"])("`args.fatal` must be a boolean.");
						else fieldObject.exFatal = fatal;
						send(fieldObject, trackerNames);
					}
				}
				var plugin = {
					require: function require(rawName, options, trackerName) {
						if (typeof ga === "function") {
							if (!rawName) {
								(0, _warn["default"])("`name` is required in .require()");
								return;
							}
							var name = (0, _trim["default"])(rawName);
							if (name === "") {
								(0, _warn["default"])("`name` cannot be an empty string in .require()");
								return;
							}
							var requireString = trackerName ? "".concat(trackerName, ".require") : "require";
							if (options) {
								if (_typeof(options) !== "object") {
									(0, _warn["default"])("Expected `options` arg to be an Object");
									return;
								}
								if (Object.keys(options).length === 0) (0, _warn["default"])("Empty `options` given to .require()");
								ga(requireString, name, options);
								if (_debug) (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
							} else {
								ga(requireString, name);
								if (_debug) (0, _log["default"])("called ga('require', '".concat(name, "');"));
							}
						}
					},
					execute: function execute(pluginName, action) {
						var payload;
						var actionType;
						for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) args[_key3 - 2] = arguments[_key3];
						if (args.length === 1) payload = args[0];
						else {
							actionType = args[0];
							payload = args[1];
						}
						if (typeof ga === "function") if (typeof pluginName !== "string") (0, _warn["default"])("Expected `pluginName` arg to be a String.");
						else if (typeof action !== "string") (0, _warn["default"])("Expected `action` arg to be a String.");
						else {
							var command = "".concat(pluginName, ":").concat(action);
							payload = payload || null;
							if (actionType && payload) {
								ga(command, actionType, payload);
								if (_debug) {
									(0, _log["default"])("called ga('".concat(command, "');"));
									(0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
								}
							} else if (payload) {
								ga(command, payload);
								if (_debug) {
									(0, _log["default"])("called ga('".concat(command, "');"));
									(0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
								}
							} else {
								ga(command);
								if (_debug) (0, _log["default"])("called ga('".concat(command, "');"));
							}
						}
					}
				};
				/**
				* outboundLink:
				* GA outboundLink tracking
				* @param args.label {String} e.g. url, or 'Create an Account'
				* @param {function} hitCallback - Called after processing a hit.
				*/
				exports$5.plugin = plugin;
				function outboundLink(args, hitCallback, trackerNames) {
					if (typeof hitCallback !== "function") {
						(0, _warn["default"])("hitCallback function is required");
						return;
					}
					if (typeof ga === "function") {
						if (!args || !args.label) {
							(0, _warn["default"])("args.label is required in outboundLink()");
							return;
						}
						var fieldObject = {
							hitType: "event",
							eventCategory: "Outbound",
							eventAction: "Click",
							eventLabel: _format(args.label)
						};
						var safetyCallbackCalled = false;
						var t = setTimeout(function safetyCallback() {
							safetyCallbackCalled = true;
							hitCallback();
						}, 250);
						fieldObject.hitCallback = function clearableCallbackForGA() {
							clearTimeout(t);
							if (!safetyCallbackCalled) hitCallback();
						};
						send(fieldObject, trackerNames);
					} else setTimeout(hitCallback, 0);
				}
				exports$5.testModeAPI = _testModeAPI["default"];
				exports$5["default"] = {
					initialize,
					ga,
					set,
					send,
					pageview,
					modalview,
					timing,
					event,
					exception,
					plugin,
					outboundLink,
					testModeAPI: _testModeAPI["default"]
				};
			}),
			(function(module$6, exports$6, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$6, "__esModule", { value: true });
				exports$6["default"] = format;
				var _redactEmail = _interopRequireDefault(__webpack_require__(4));
				var _toTitleCase = _interopRequireDefault(__webpack_require__(6));
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				function format() {
					var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
					var titleCase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
					var redactingEmail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
					var _str = s || "";
					if (titleCase) _str = (0, _toTitleCase["default"])(s);
					if (redactingEmail) _str = (0, _redactEmail["default"])(_str);
					return _str;
				}
			}),
			(function(module$7, exports$7, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$7, "__esModule", { value: true });
				exports$7["default"] = redactEmail;
				var _warn = _interopRequireDefault(__webpack_require__(0));
				var _mightBeEmail = _interopRequireDefault(__webpack_require__(5));
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				var redacted = "REDACTED (Potential Email Address)";
				function redactEmail(string) {
					if ((0, _mightBeEmail["default"])(string)) {
						(0, _warn["default"])("This arg looks like an email address, redacting.");
						return redacted;
					}
					return string;
				}
			}),
			(function(module$8, exports$8, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$8, "__esModule", { value: true });
				exports$8["default"] = mightBeEmail;
				function mightBeEmail(s) {
					return typeof s === "string" && s.indexOf("@") !== -1;
				}
			}),
			(function(module$9, exports$9, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$9, "__esModule", { value: true });
				exports$9["default"] = toTitleCase;
				var _trim = _interopRequireDefault(__webpack_require__(1));
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				/**
				* To Title Case 2.1 - http://individed.com/code/to-title-case/
				* Copyright 2008-2013 David Gouch. Licensed under the MIT License.
				* https://github.com/gouch/to-title-case
				*/
				var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
				function toTitleCase(string) {
					return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
						if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
						if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
						return match.charAt(0).toUpperCase() + match.substr(1);
					});
				}
			}),
			(function(module$10, exports$10, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$10, "__esModule", { value: true });
				exports$10["default"] = removeLeadingSlash;
				function removeLeadingSlash(string) {
					if (string.substring(0, 1) === "/") return string.substring(1);
					return string;
				}
			}),
			(function(module$11, exports$11, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$11, "__esModule", { value: true });
				exports$11["default"] = _default;
				var isLoaded = false;
				function _default(options) {
					if (isLoaded) return;
					isLoaded = true;
					var gaAddress = "https://www.google-analytics.com/analytics.js";
					if (options && options.gaAddress) gaAddress = options.gaAddress;
					else if (options && options.debug) gaAddress = "https://www.google-analytics.com/analytics_debug.js";
					var onerror = options && options.onerror;
					(function(i, s, o, g, r, a, m) {
						i["GoogleAnalyticsObject"] = r;
						i[r] = i[r] || function() {
							(i[r].q = i[r].q || []).push(arguments);
						}, i[r].l = 1 * /* @__PURE__ */ new Date();
						a = s.createElement(o), m = s.getElementsByTagName(o)[0];
						a.async = 1;
						a.src = g;
						a.onerror = onerror;
						m.parentNode.insertBefore(a, m);
					})(window, document, "script", gaAddress, "ga");
				}
			}),
			(function(module$12, exports$12, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$12, "__esModule", { value: true });
				exports$12["default"] = log;
				function log(s) {
					console.info("[react-ga]", s);
				}
			}),
			(function(module$13, exports$13, __webpack_require__) {
				"use strict";
				Object.defineProperty(exports$13, "__esModule", { value: true });
				exports$13.gaCalls = exports$13["default"] = void 0;
				var gaCalls = [];
				exports$13.gaCalls = gaCalls;
				exports$13["default"] = {
					calls: gaCalls,
					ga: function ga() {
						for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
						gaCalls.push([].concat(args));
					},
					resetCalls: function resetCalls() {
						gaCalls.length = 0;
					}
				};
			}),
			(function(module$14, exports$14, __webpack_require__) {
				"use strict";
				function _typeof(obj) {
					"@babel/helpers - typeof";
					return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
						return typeof obj;
					} : function(obj) {
						return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
					}, _typeof(obj);
				}
				Object.defineProperty(exports$14, "__esModule", { value: true });
				exports$14.timing = exports$14.testModeAPI = exports$14.set = exports$14.send = exports$14.plugin = exports$14.pageview = exports$14.outboundLink = exports$14.modalview = exports$14.initialize = exports$14.ga = exports$14.exception = exports$14.event = exports$14["default"] = exports$14.addTrackers = exports$14.OutboundLink = void 0;
				var _OutboundLink = _interopRequireDefault(__webpack_require__(12));
				var Defaults = _interopRequireWildcard(__webpack_require__(2));
				function _getRequireWildcardCache(nodeInterop) {
					if (typeof WeakMap !== "function") return null;
					var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
					var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
					return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
						return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
					})(nodeInterop);
				}
				function _interopRequireWildcard(obj, nodeInterop) {
					if (!nodeInterop && obj && obj.__esModule) return obj;
					if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return { "default": obj };
					var cache = _getRequireWildcardCache(nodeInterop);
					if (cache && cache.has(obj)) return cache.get(obj);
					var newObj = {};
					var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
					for (var key in obj) if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
						var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
						if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
						else newObj[key] = obj[key];
					}
					newObj["default"] = obj;
					if (cache) cache.set(obj, newObj);
					return newObj;
				}
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				function ownKeys(object, enumerableOnly) {
					var keys = Object.keys(object);
					if (Object.getOwnPropertySymbols) {
						var symbols = Object.getOwnPropertySymbols(object);
						enumerableOnly && (symbols = symbols.filter(function(sym) {
							return Object.getOwnPropertyDescriptor(object, sym).enumerable;
						})), keys.push.apply(keys, symbols);
					}
					return keys;
				}
				function _objectSpread(target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = null != arguments[i] ? arguments[i] : {};
						i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
							_defineProperty(target, key, source[key]);
						}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
							Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
						});
					}
					return target;
				}
				function _defineProperty(obj, key, value) {
					if (key in obj) Object.defineProperty(obj, key, {
						value,
						enumerable: true,
						configurable: true,
						writable: true
					});
					else obj[key] = value;
					return obj;
				}
				exports$14.initialize = Defaults.initialize;
				exports$14.addTrackers = Defaults.addTrackers;
				exports$14.ga = Defaults.ga;
				exports$14.set = Defaults.set;
				exports$14.send = Defaults.send;
				exports$14.pageview = Defaults.pageview;
				exports$14.modalview = Defaults.modalview;
				exports$14.timing = Defaults.timing;
				exports$14.event = Defaults.event;
				exports$14.exception = Defaults.exception;
				exports$14.plugin = Defaults.plugin;
				exports$14.outboundLink = Defaults.outboundLink;
				exports$14.testModeAPI = Defaults.testModeAPI;
				_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
				_OutboundLink["default"].trackLink = Defaults.outboundLink;
				var OutboundLink = _OutboundLink["default"];
				exports$14.OutboundLink = OutboundLink;
				exports$14["default"] = _objectSpread(_objectSpread({}, Defaults), {}, { OutboundLink });
			}),
			(function(module$15, exports$15, __webpack_require__) {
				"use strict";
				function _typeof(obj) {
					"@babel/helpers - typeof";
					return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
						return typeof obj;
					} : function(obj) {
						return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
					}, _typeof(obj);
				}
				Object.defineProperty(exports$15, "__esModule", { value: true });
				exports$15["default"] = void 0;
				var _react = _interopRequireWildcard(__webpack_require__(13));
				var _propTypes = _interopRequireDefault(__webpack_require__(14));
				var _warn = _interopRequireDefault(__webpack_require__(0));
				var _excluded = ["to", "target"];
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { "default": obj };
				}
				function _getRequireWildcardCache(nodeInterop) {
					if (typeof WeakMap !== "function") return null;
					var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
					var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
					return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
						return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
					})(nodeInterop);
				}
				function _interopRequireWildcard(obj, nodeInterop) {
					if (!nodeInterop && obj && obj.__esModule) return obj;
					if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return { "default": obj };
					var cache = _getRequireWildcardCache(nodeInterop);
					if (cache && cache.has(obj)) return cache.get(obj);
					var newObj = {};
					var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
					for (var key in obj) if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
						var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
						if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
						else newObj[key] = obj[key];
					}
					newObj["default"] = obj;
					if (cache) cache.set(obj, newObj);
					return newObj;
				}
				function ownKeys(object, enumerableOnly) {
					var keys = Object.keys(object);
					if (Object.getOwnPropertySymbols) {
						var symbols = Object.getOwnPropertySymbols(object);
						enumerableOnly && (symbols = symbols.filter(function(sym) {
							return Object.getOwnPropertyDescriptor(object, sym).enumerable;
						})), keys.push.apply(keys, symbols);
					}
					return keys;
				}
				function _objectSpread(target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = null != arguments[i] ? arguments[i] : {};
						i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
							_defineProperty(target, key, source[key]);
						}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
							Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
						});
					}
					return target;
				}
				function _objectWithoutProperties(source, excluded) {
					if (source == null) return {};
					var target = _objectWithoutPropertiesLoose(source, excluded);
					var key, i;
					if (Object.getOwnPropertySymbols) {
						var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
						for (i = 0; i < sourceSymbolKeys.length; i++) {
							key = sourceSymbolKeys[i];
							if (excluded.indexOf(key) >= 0) continue;
							if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
							target[key] = source[key];
						}
					}
					return target;
				}
				function _objectWithoutPropertiesLoose(source, excluded) {
					if (source == null) return {};
					var target = {};
					var sourceKeys = Object.keys(source);
					var key, i;
					for (i = 0; i < sourceKeys.length; i++) {
						key = sourceKeys[i];
						if (excluded.indexOf(key) >= 0) continue;
						target[key] = source[key];
					}
					return target;
				}
				function _classCallCheck(instance, Constructor) {
					if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
				}
				function _defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];
						descriptor.enumerable = descriptor.enumerable || false;
						descriptor.configurable = true;
						if ("value" in descriptor) descriptor.writable = true;
						Object.defineProperty(target, descriptor.key, descriptor);
					}
				}
				function _createClass(Constructor, protoProps, staticProps) {
					if (protoProps) _defineProperties(Constructor.prototype, protoProps);
					if (staticProps) _defineProperties(Constructor, staticProps);
					Object.defineProperty(Constructor, "prototype", { writable: false });
					return Constructor;
				}
				function _inherits(subClass, superClass) {
					if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
					subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: {
						value: subClass,
						writable: true,
						configurable: true
					} });
					Object.defineProperty(subClass, "prototype", { writable: false });
					if (superClass) _setPrototypeOf(subClass, superClass);
				}
				function _setPrototypeOf(o, p) {
					_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
						o.__proto__ = p;
						return o;
					};
					return _setPrototypeOf(o, p);
				}
				function _createSuper(Derived) {
					var hasNativeReflectConstruct = _isNativeReflectConstruct();
					return function _createSuperInternal() {
						var Super = _getPrototypeOf(Derived), result;
						if (hasNativeReflectConstruct) {
							var NewTarget = _getPrototypeOf(this).constructor;
							result = Reflect.construct(Super, arguments, NewTarget);
						} else result = Super.apply(this, arguments);
						return _possibleConstructorReturn(this, result);
					};
				}
				function _possibleConstructorReturn(self, call) {
					if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
					else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
					return _assertThisInitialized(self);
				}
				function _assertThisInitialized(self) {
					if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
					return self;
				}
				function _isNativeReflectConstruct() {
					if (typeof Reflect === "undefined" || !Reflect.construct) return false;
					if (Reflect.construct.sham) return false;
					if (typeof Proxy === "function") return true;
					try {
						Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
						return true;
					} catch (e) {
						return false;
					}
				}
				function _getPrototypeOf(o) {
					_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
						return o.__proto__ || Object.getPrototypeOf(o);
					};
					return _getPrototypeOf(o);
				}
				function _defineProperty(obj, key, value) {
					if (key in obj) Object.defineProperty(obj, key, {
						value,
						enumerable: true,
						configurable: true,
						writable: true
					});
					else obj[key] = value;
					return obj;
				}
				var NEWTAB = "_blank";
				var MIDDLECLICK = 1;
				var OutboundLink = /* @__PURE__ */ function(_Component) {
					_inherits(OutboundLink, _Component);
					var _super = _createSuper(OutboundLink);
					function OutboundLink() {
						var _this;
						_classCallCheck(this, OutboundLink);
						for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
						_this = _super.call.apply(_super, [this].concat(args));
						_defineProperty(_assertThisInitialized(_this), "handleClick", function(event) {
							var _this$props = _this.props, target = _this$props.target, eventLabel = _this$props.eventLabel, to = _this$props.to, onClick = _this$props.onClick, trackerNames = _this$props.trackerNames;
							var eventMeta = { label: eventLabel };
							var sameTarget = target !== NEWTAB;
							var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
							if (sameTarget && normalClick) {
								event.preventDefault();
								OutboundLink.trackLink(eventMeta, function() {
									window.location.href = to;
								}, trackerNames);
							} else OutboundLink.trackLink(eventMeta, function() {}, trackerNames);
							if (onClick) onClick(event);
						});
						return _this;
					}
					_createClass(OutboundLink, [{
						key: "render",
						value: function render() {
							var _this$props2 = this.props, href = _this$props2.to, target = _this$props2.target;
							var props = _objectSpread(_objectSpread({}, _objectWithoutProperties(_this$props2, _excluded)), {}, {
								target,
								href,
								onClick: this.handleClick
							});
							if (target === NEWTAB) props.rel = "".concat(props.rel ? props.rel : "", " noopener noreferrer").trim();
							delete props.eventLabel;
							delete props.trackerNames;
							return /* @__PURE__ */ _react["default"].createElement("a", props);
						}
					}]);
					return OutboundLink;
				}(_react.Component);
				exports$15["default"] = OutboundLink;
				_defineProperty(OutboundLink, "trackLink", function() {
					(0, _warn["default"])("ga tracking not enabled");
				});
				OutboundLink.propTypes = {
					eventLabel: _propTypes["default"].string.isRequired,
					target: _propTypes["default"].string,
					to: _propTypes["default"].string,
					onClick: _propTypes["default"].func,
					trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
				};
				OutboundLink.defaultProps = {
					target: null,
					to: null,
					onClick: null,
					trackerNames: null
				};
			}),
			(function(module$16, exports$16) {
				module$16.exports = __WEBPACK_EXTERNAL_MODULE__13__;
			}),
			(function(module$17, exports$17) {
				module$17.exports = __WEBPACK_EXTERNAL_MODULE__14__;
			})
		]);
	});
})))();
//#endregion
//#region ../../apps/vms/src/backend/reducers/map-notes-reducer.js
const ActionConstants = {
	SET_MAP_NOTELETS: "SET_MAP_NOTELETS",
	SET_MAP_NOTE_FILTER: "SET_MAP_NOTE_FILTER",
	SET_TOTALS: "SET_TOTALS",
	SET_SHOW_NOTES_ON_MAP: "SET_SHOW_NOTES_ON_MAP",
	TOGGLE_NOTES_ON_MAP: "TOGGLE_NOTES_ON_MAP",
	SET_SELECTED_MAP_NOTE: "SET_SELECTED_MAPNOTE",
	SET_UPDATED_FIELDS: "SET_UPDATED_FIELDS",
	SET_SHOW_TYPE_DROPDOWN: "SET_SHOW_TYPE_DROPDOWN",
	SET_SHOW_TRASH_MAP_NOTE_MODAL: "SET_SHOW_TRASH_MAP_NOTE_MODAL",
	SET_SHOW_EXIT_MAP_NOTE_MODAL: "SET_SHOW_EXIT_MAP_NOTE_MODAL",
	SET_SHOW_CANCEL_CHANGES_MODAL: "SET_SHOW_CANCEL_CHANGES_MODAL",
	CLEAR_UPDATED_FIELDS: "CLEAR_UPDATED_FIELDS",
	SET_COMMENT: "SET_COMMENT",
	SET_SHEET_VERSION: "SET_SHEET_VERSION",
	SET_LOADING: "SET_LOADING",
	SET_DROPDOWN_SHOWING: "SET_DROPDOWN_SHOWING",
	SET_FILTER_EXPANDED: "SET_FILTER_EXPANDED"
};
def$1(ActionConstants.SET_MAP_NOTE_FILTER, "filter"), def$1(ActionConstants.SET_TOTALS, "totals"), def$1(ActionConstants.SET_MAP_NOTELETS, "mapNotelets"), def$1(ActionConstants.SET_SHOW_NOTES_ON_MAP, "showNotesOnMap"), def$1(ActionConstants.TOGGLE_NOTES_ON_MAP, "showNotesOnMap"), def$1(ActionConstants.SET_SELECTED_MAP_NOTE, "selectedMapNote"), def$1(ActionConstants.SET_UPDATED_FIELDS, "updatedFields"), def$1(ActionConstants.SET_SHOW_TYPE_DROPDOWN, "showTypeDropdown"), def$1(ActionConstants.SET_SHOW_TRASH_MAP_NOTE_MODAL, "showTrashMapNoteModal"), def$1(ActionConstants.SET_SHOW_EXIT_MAP_NOTE_MODAL, "showExitMapNoteModal"), def$1(ActionConstants.SET_SHOW_CANCEL_CHANGES_MODAL, "showCancelChangesModal"), def$1(ActionConstants.CLEAR_UPDATED_FIELDS, "updatedFields"), def$1(ActionConstants.SET_COMMENT, "comment"), def$1(ActionConstants.SET_SHEET_VERSION, "sheetVersion"), def$1(ActionConstants.SET_LOADING, "loading"), def$1(ActionConstants.SET_DROPDOWN_SHOWING, "dropdownShowing", "venueId"), def$1(ActionConstants.SET_FILTER_EXPANDED, "filterExpanded");
const findMapNotesOnLevels = (masterState) => calculateMapNotesOnLevels(masterState.mapNotes);
const getSelectedMapNote = (masterState) => masterState.mapNotes.selectedMapNote;
const getSheetVersion = (masterState) => masterState.mapNotes.sheetVersion;
const getLoading = (masterState) => masterState.mapNotes.loading;
const getTotals = (masterState) => masterState.mapNotes.totals;
const getMapNotelets = (masterState) => masterState.mapNotes.mapNotelets;
const getMapNotesFilter = (masterState) => masterState.mapNotes.filter;
const getMapNotesFilterAmount = (masterState) => calculateMapNotesFilterAmount(masterState.mapNotes);
const getMapNotesFilterLabel = (masterState) => Functional.capitalizeFirst(masterState.mapNotes.filter.status);
const getShowExitMapNoteModal = (masterState) => masterState.mapNotes.showExitMapNoteModal;
const getShowNotesOnMap = (masterState) => masterState.mapNotes.showNotesOnMap;
const getShowTrashMapNoteModal = (masterState) => masterState.mapNotes.showTrashMapNoteModal;
const getShowCancelChangesModal = (masterState) => masterState.mapNotes.showCancelChangesModal;
const getComment = (masterState) => masterState.mapNotes.comment;
const getUpdatedFields = (masterState) => masterState.mapNotes.updatedFields;
const isTypeDropdownOpen = (masterState) => masterState.mapNotes.showTypeDropdown;
const getDropdownShowing = (masterState) => masterState.mapNotes.dropdownShowing;
const getFilterExpanded = (masterState) => masterState.mapNotes.filterExpanded;
const getConvertedMapNoteletsAsGeoJson = (masterState, ordinal) => calculateGeoJson(masterState.mapNotes, ordinal);
const getMapNotelet = R.curry((masterState, id) => R.find(R.propEq(id, "id"), getMapNotelets(masterState)));
const getFilterAmount = (totals, filterStatus) => {
	const totalAmount = R.propOr(0, "open", totals) + R.propOr(0, "resolved", totals);
	return filterStatus === "all" ? totalAmount : R.propOr(0, filterStatus, totals);
};
const calculateLevelsWithMapNotes = (mapNotelets) => R.uniq(R.without([void 0], R.map(getOrdinal, mapNotelets)));
const convertToGeoJson = (mapNotelet, selectedMapNoteId) => ({
	type: "Feature",
	geometry: {
		type: "Point",
		coordinates: [Number(mapNotelet.location.longitude), Number(mapNotelet.location.latitude)]
	},
	properties: {
		status: R.equals(mapNotelet.id, selectedMapNoteId) || R.equals(mapNotelet.id, -1) ? "mapnote.selected" : `mapnote.${mapNotelet.noteStatus}`,
		noteId: mapNotelet.id,
		venueId: mapNotelet.location.venueId
	}
});
const getFilteredMapNotelets = (mapNotelets, status, type, ordinal, currentId) => {
	const mapNoteFilter = (note) => R.includes(note.noteStatus, status) && R.includes(note.noteType, R.flatten([R.keys(R.filter((val) => val, type)), type.noType ? [""] : []])) && `ordinal: ${ordinal ? ordinal.ordinalNumber : parseInt("1", 10)}` === note.location.ordinalId || note.id < 0 || !R.isNil(currentId) && note.id === currentId;
	return R.filter(mapNoteFilter, mapNotelets);
};
const calculateMapNotesFilterAmount = (mapNotes) => getFilterAmount(mapNotes.totals, mapNotes.filter.status);
const getOrdinal = (mapNote) => {
	if (mapNote.noteStatus === "open") return {
		ordinalId: mapNote.location.ordinalId,
		structureId: mapNote.location.structureId
	};
};
const calculateMapNotesOnLevels = (mapNotes) => calculateLevelsWithMapNotes(mapNotes.mapNotelets);
const calculateStatus = (status) => status === "all" ? ["open", "resolved"] : [status];
const _calculateGeoJson = (mapNotes, ordinal) => {
	if (!ordinal) return [];
	if (!mapNotes.showNotesOnMap) return [];
	const selectedMapNoteId = R.isNil(mapNotes.selectedMapNote) ? null : mapNotes.selectedMapNote.id;
	const filteredMapNotelets = getFilteredMapNotelets(mapNotes.mapNotelets, calculateStatus(mapNotes.filter.status), mapNotes.filter.type, ordinal, selectedMapNoteId);
	return R.map((mapNotelet) => convertToGeoJson(mapNotelet, selectedMapNoteId), filteredMapNotelets);
};
const haveMapNotesChanged = (mapNotes, ordinal) => ({
	ordinal,
	showNotesOnMap: mapNotes.showNotesOnMap,
	mapNotelet: mapNotes.mapNotelets,
	selectedMapNote: mapNotes.selectedMapNote,
	filterStatus: mapNotes.filter.status,
	filterType: mapNotes.filter.type
});
const calculateGeoJson = Functional.memoizeOnceWithObject(haveMapNotesChanged, _calculateGeoJson);
const Selectors = {
	getTotals,
	getMapNotelets,
	getMapNotesFilter,
	getShowNotesOnMap,
	getMapNotesFilterLabel,
	getMapNotesFilterAmount,
	getConvertedMapNoteletsAsGeoJson,
	findMapNotesOnLevels,
	getSelectedMapNote,
	isTypeDropdownOpen,
	getUpdatedFields,
	getShowExitMapNoteModal,
	getShowTrashMapNoteModal,
	getShowCancelChangesModal,
	getComment,
	getSheetVersion,
	getLoading,
	getDropdownShowing,
	getMapNotelet,
	getFilterExpanded
};
//#endregion
//#region src/map-api.ts
const NAV_LINE_SOURCE = "navlineSource";
const MAP_NOTES_SOURCE = "mapNotes";
const zoomToBoundingBox = (oldViewport, boundingBox, TRANSITION_DURATION) => {
	const { n, w, s, e } = boundingBox;
	let bounds = new WebMercatorViewport({
		width: oldViewport.width,
		height: oldViewport.height
	}).fitBounds([[e, n], [w, s]], { padding: 40 });
	bounds = pick([
		"latitude",
		"longitude",
		"zoom"
	], bounds);
	bounds = assoc("transitionDuration", TRANSITION_DURATION, bounds);
	return mergeRight(oldViewport, bounds);
};
const clampBounds = (viewport, boundingBox) => {
	if (viewport.latitude === 0 || viewport.longitude === 0 || !boundingBox) return viewport;
	const { n, s, e, w } = boundingBox;
	return mergeRight(viewport, {
		latitude: clamp(s, n, viewport.latitude),
		longitude: clamp(w, e, viewport.longitude)
	});
};
const prioritizeAmongFeatures = Functional.condNotNil(find((f) => f.source === NAV_LINE_SOURCE), find((f) => f.source === MAP_NOTES_SOURCE), find((f) => "aiLayer" in f.properties && f.properties.aiLayer === "poi"), find((f) => "category" in f.properties && f.properties.category === "unoccupied"), head);
const wrapAction = (eventType, o = {}) => mergeRight({ eventType }, o);
const determineActionFromFeature = (mapboxFeatures) => {
	const rawFeature = prioritizeAmongFeatures(mapboxFeatures);
	const entityId = Functional.pathString("properties.id", rawFeature);
	const mapNoteId = Functional.pathString("properties.noteId", rawFeature);
	const isPoi = Functional.pathStringEq("properties.aiLayer", "poi", rawFeature);
	const isUnoccupied = Functional.pathStringEq("properties.category", "unoccupied", rawFeature);
	if (entityId && isUnoccupied) return wrapAction("EDIT_ENTITY", {
		entityId,
		rawFeature
	});
	if (entityId && isPoi) return wrapAction("EDIT_ENTITY", { entityId });
	if (mapNoteId) return wrapAction("EDIT_MAP_NOTE", { mapNoteId });
	return wrapAction("NOTHING_CLICKED");
};
const determineMapClickAction = (mode, mapboxFeatures) => {
	if (mode.poiClick) return wrapAction("ADD_ENTITY");
	if (mode.noteClick) return wrapAction("ADD_MAP_NOTE");
	if (mode.movePoiMode) return wrapAction("MOVE_ENTITY");
	return determineActionFromFeature(mapboxFeatures);
};
let currentRouteIndex = 2;
const mockRoutes = [
	{
		startLocation: "The Front Porch",
		endLocation: "Gate 41"
	},
	{
		startLocation: "The Front Porch",
		endLocation: "AA Baggage"
	},
	{
		startLocation: "",
		endLocation: ""
	}
];
const incrementRoute = () => {
	currentRouteIndex = (currentRouteIndex + 1) % mockRoutes.length;
	return mockRoutes[currentRouteIndex];
};
const navigate = () => {
	const { startLocation, endLocation } = incrementRoute();
	return {
		startLocation,
		endLocation,
		segments: Wayfinding.navigate(startLocation, endLocation)
	};
};
const navlineFeatures = (state) => {
	const { currentOrdinalId } = state;
	const segments = filter(propEq(currentOrdinalId, "ordinalId"), state.wayfinding.segments);
	return chain(WayfindingSegment.toGeoJson, segments);
};
const layerWarning = (feature, layerType, geometryType) => {
	return `${layerType} layer '${Functional.pathString("layer.id", feature)}' has incorrect geometry type: ${geometryType} for venue: ${Functional.pathString("properties.venueId", feature)} id: ${Functional.pathString("properties.id", feature)} subid: ${Functional.pathString("properties.subid", feature)}`;
};
const geometryMatchesLayer = (layer, geometry) => {
	switch (layer) {
		case "symbol": return geometry === "Point";
		case "fill": return geometry === "Polygon" || geometry === "MultiPolygon";
		case "line": return geometry === "LineString" || geometry === "Polygon" || geometry === "MultiLineString";
		default: return true;
	}
};
const validateFeatureOnLayer = (feature) => {
	const layerType = path(["layer", "type"], feature);
	const geometryType = path(["geometry", "type"], feature);
	if (!geometryMatchesLayer(layerType, geometryType)) console.error(layerWarning(feature, layerType, geometryType));
};
const validateFeaturesOnLayer = forEach(validateFeatureOnLayer);
//#endregion
//#region src/style-airport.ts
const defaultMapStyle = (ordinalSource, selectedIds) => ({
	version: 8,
	metadata: {
		"mapbox:autocomposite": true,
		"mapbox:type": "template",
		"mapbox:sdk-support": {
			js: "0.50.0",
			android: "6.7.0",
			ios: "4.6.0"
		},
		"mapbox:groups": {}
	},
	center: [-79.93644098323023, 36.10490606002804],
	light: {
		intensity: .1,
		color: "hsl(0, 0%, 100%)"
	},
	sprite: "https://content.locuslabs.com/airport/spritesheet-mapbox/spritesheet",
	glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
	layers: [
		{
			id: "background",
			type: "background",
			paint: { "background-color": "hsl(0, 0%, 95%)" },
			source: ""
		},
		{
			id: "basemap",
			type: "fill",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					[
						"concrete",
						"runways",
						"structures"
					],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					["get", "fillColor"],
					19.5,
					["get", "fillColor"]
				],
				"fill-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					0,
					1,
					19,
					1,
					20,
					0
				]
			}
		},
		{
			id: "parking",
			type: "fill-extrusion",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["parking"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 10,
				"fill-extrusion-color": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					"hsl(0, 0%, 78%)",
					16,
					["get", "fillColor"]
				]
			}
		},
		{
			id: "basemap.curb",
			type: "fill",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["basemap.curb"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": ["get", "fillColor"],
				"fill-opacity": 1,
				"fill-outline-color": "hsla(0, 0%, 0%, 0)"
			}
		},
		{
			id: "jetway arm",
			type: "line",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["jetways"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					["jetway", "basemap.jetway"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": ["get", "strokeColor"],
				"line-width": [
					"interpolate",
					["exponential", 1.8],
					["zoom"],
					0,
					3,
					22,
					100
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					1,
					1,
					15,
					0,
					19,
					1,
					20,
					0
				]
			}
		},
		{
			id: "jetway bubble",
			type: "fill",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["jetway.bubble", "basemap.jetwaybubble"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": ["get", "fillColor"],
				"fill-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					0,
					16.5,
					1,
					18.5,
					1,
					19.5,
					0
				]
			}
		},
		{
			id: "outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["outline"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": ["get", "strokeColor"],
				"line-width": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17.5,
					.5
				]
			}
		},
		{
			id: "ailayer-outline",
			type: "fill",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["outline"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: { "fill-color": ["get", "fillColor"] }
		},
		{
			id: "non-accessible",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["element.nonaccessible", "non accessible"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 1,
				"fill-extrusion-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "fillColor"]
				],
				"fill-extrusion-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					1,
					0,
					17.5,
					1
				]
			}
		},
		{
			id: "nonaccessible outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["non-accessible", "misc"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"basemap.curb",
						"element.arrows"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": .1
			}
		},
		{
			id: "poi polygons",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"lounge",
						"element.door",
						"door"
					],
					false,
					true
				],
				[
					"!=",
					["get", "isTouch"],
					true
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "fillColor"]
				],
				"fill-extrusion-height": 1,
				"fill-extrusion-opacity": 1
			}
		},
		{
			id: "poi outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"basemap.curb",
						"element.arrows",
						"door"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": .05
			}
		},
		{
			id: "roads",
			type: "line",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["roads"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					"hsl(0, 0%, 78%)",
					16,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					0,
					1,
					22,
					30
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					1,
					19,
					0
				]
			}
		},
		{
			id: "door",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["element.door", "door"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					22,
					30
				],
				"line-color": ["get", "strokeColor"],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17.5,
					.7
				]
			}
		},
		{
			id: "ailayer-fill",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"match",
				["geometry-type"],
				["Polygon"],
				true,
				false
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 20,
				"fill-extrusion-color": "hsl(222, 0%, 65%)",
				"fill-extrusion-opacity": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					15,
					1,
					16,
					0
				],
				"fill-extrusion-base": 0
			}
		},
		{
			id: "selected - polygon circle",
			type: "circle",
			source: ordinalSource,
			minzoom: 19,
			filter: [
				"all",
				[
					"match",
					["get", "id"],
					selectedIds,
					true,
					false
				],
				[
					"==",
					["get", "showBadge"],
					true
				]
			],
			layout: {},
			paint: {
				"circle-stroke-color": "hsla(0, 0%, 0%, 0)",
				"circle-stroke-width": 1,
				"circle-color": "hsl(0, 0%, 100%)",
				"circle-translate": [0, 0],
				"circle-radius": 28
			}
		},
		{
			id: "3 - point pois no text",
			type: "symbol",
			source: ordinalSource,
			minzoom: 19,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"==",
					["get", "showBadge"],
					true
				],
				[
					"match",
					["get", "category"],
					[
						"",
						"checkin",
						"checkin.curbside",
						"ticketing.selfcheckinkiosk",
						"security.checkpoint",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"icon-offset": [0, 0],
				"icon-image": ["get", "category"],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 0],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					20,
					1.2
				]
			},
			paint: {
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-blur": 0,
				"text-halo-width": 1.25,
				"text-color": "hsl(0, 0%, 1%)",
				"icon-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17,
					1
				]
			}
		},
		{
			id: "2 - priority point pois",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"door",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator",
						"checkin",
						"ticketing.selfcheckinkiosk",
						"checkin.curbside",
						"security.exit",
						"security.checkpoint",
						"gate"
					],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"",
						"security.exit",
						"security.checkpoint",
						"label.floor"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"icon-offset": [0, 0],
				"icon-image": ["get", "category"],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 1],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					20,
					1.2
				],
				"text-anchor": "top",
				"text-field": ["to-string", ["get", "text"]],
				"text-max-width": 5
			},
			paint: {
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					0,
					19,
					1
				],
				"text-halo-blur": .25,
				"text-halo-color": "hsl(0, 0%, 100%)",
				"icon-opacity": [
					"interpolate",
					["exponential", 1],
					["zoom"],
					17,
					0,
					17.5,
					1
				],
				"text-halo-width": 1
			}
		},
		{
			id: "2 - polygon pois",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"gate",
						"checkin",
						"checkin.curbside",
						"ticketing.selfcheckinkiosk",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator",
						"label.floor"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"!=",
					["get", "showBadge"],
					true
				]
			],
			layout: {
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"text-field": ["to-string", ["get", "text"]]
			},
			paint: {
				"text-halo-blur": .25,
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					0,
					18.5,
					1
				],
				"text-halo-width": 1
			}
		},
		{
			id: "1 - security and building labels",
			type: "symbol",
			source: ordinalSource,
			minzoom: 16,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"security.checkpoint",
						"element.securitythreshold",
						"label.floor"
					],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					14,
					22,
					40
				],
				"icon-offset": [0, -25],
				"text-font": ["Open Sans Bold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 0],
				"icon-size": 1,
				"text-anchor": "top",
				"text-field": ["to-string", ["get", "text"]]
			},
			paint: {
				"icon-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17,
					1
				],
				"text-halo-blur": 1,
				"text-halo-width": 1,
				"text-color": ["get", "textColor"],
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					15,
					0,
					16,
					1
				],
				"text-halo-color": "hsl(0, 0%, 100%)"
			}
		},
		{
			id: "1 - jetway label",
			type: "symbol",
			source: "landscape-background",
			minzoom: 16,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["jetways"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"basemap.jetwaybubble",
						"jetway",
						"jetway.bubble"
					],
					true,
					false
				],
				["has", "text"]
			],
			layout: {
				"text-field": ["to-string", ["get", "text"]],
				"text-offset": [0, 0],
				"text-font": ["Open Sans Bold", "Arial Unicode MS Regular"],
				"text-size": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					15,
					8,
					22,
					200
				]
			},
			paint: {
				"text-color": ["get", "textColor"],
				"text-halo-width": 0,
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					1,
					19.5,
					0
				]
			}
		},
		{
			id: "navgiation line shadow",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				["has", "segmentType"]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					60
				],
				"line-blur": 40,
				"line-gap-width": 0,
				"line-translate": [0, 0],
				"line-offset": -5,
				"line-color": "hsla(0, 0%, 0%, 0.6)"
			}
		},
		{
			id: "navgiation line stroke",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				["has", "segmentType"]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					36
				],
				"line-color": "hsl(222, 0%, 100%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navgiation line - walk",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["get", "segmentType"],
					["walk"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round",
				"line-round-limit": 0
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					30
				],
				"line-color": "hsl(222, 83%, 53%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navgiation line - sec",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["get", "segmentType"],
					["security"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					30
				],
				"line-color": "hsl(0, 68%, 57%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navigation icon - security",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["security"],
					true,
					false
				]
			],
			layout: {
				"icon-image": ["get", "badge"],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"icon-offset": [0, 0],
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"text-offset": [0, 2.2],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"]
			},
			paint: {
				"text-color": "#dc4747",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": 2,
				"text-halo-blur": .5
			}
		},
		{
			id: "navigation icon - end",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["wayfinding-end"],
					true,
					false
				]
			],
			layout: {
				"icon-image": ["get", "badge"],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"icon-offset": [0, -37],
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"text-offset": [0, 1.5],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"]
			},
			paint: {
				"text-color": "#4d4563",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": .75,
				"text-halo-blur": .5
			}
		},
		{
			id: "navigation icon - start",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["wayfinding-start"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"icon-offset": [0, -37],
				"icon-image": ["get", "badge"],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"],
				"text-justify": "right",
				"text-offset": [1, -1.5],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"text-anchor": "left",
				"text-field": "You are here"
			},
			paint: {
				"text-color": "#404a59",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": 1,
				"text-halo-blur": .5
			}
		},
		{
			id: "map notes",
			type: "symbol",
			source: "mapNotes",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				["has", "status"]
			],
			layout: {
				"icon-image": ["get", "status"],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					13.5,
					.5,
					20,
					1.2
				],
				"icon-allow-overlap": true,
				"icon-padding": 10
			},
			paint: { "icon-opacity": [
				"interpolate",
				["exponential", 1.9],
				["zoom"],
				13.5,
				0,
				15,
				1
			] }
		},
		{
			id: "selected state",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"match",
				["geometry-type"],
				["Point"],
				true,
				false
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"text-allow-overlap": true,
				"icon-offset": [0, 0],
				"icon-image": [
					"match",
					["get", "id"],
					selectedIds,
					[
						"concat",
						"",
						["get", "category"]
					],
					""
				],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"icon-allow-overlap": true,
				"text-offset": [0, 1.5],
				"text-anchor": "top",
				"text-field": [
					"match",
					["get", "id"],
					selectedIds,
					["to-string", ["get", "text"]],
					""
				]
			},
			paint: {
				"text-halo-blur": .25,
				"text-halo-width": [
					"match",
					["get", "id"],
					selectedIds,
					1.5,
					1
				],
				"text-opacity": [
					"match",
					["get", "id"],
					selectedIds,
					1,
					0
				],
				"text-halo-color": [
					"match",
					["get", "id"],
					selectedIds,
					"#000000",
					"#ffffff"
				],
				"text-color": [
					"match",
					["get", "id"],
					selectedIds,
					"#FFFFFF",
					"hsl(256, 0%, 0%)"
				]
			}
		}
	],
	created: "2019-04-26T20:00:12.025Z",
	id: "cjuyi30em1c2v1fqq8bmhie6y",
	modified: "2019-04-26T20:08:09.927Z",
	draft: false
});
//#endregion
//#region src/reducer.ts
const TRANSITION_DURATION = 500;
const { VENUE_LOADING_FINISHED } = LandscapeState.actions;
const SELECT_NO_ENTITIES = ["this \"id\" will not match any entity"];
const DESELECT_ALL_FEATURES = "DESELECT_ALL_FEATURES";
const SELECT_FEATURES_FOR_ENTITIES = "SELECT_FEATURES_FOR_ENTITIES";
const SHOW_ORDINAL = "SHOW_ORDINAL";
const SHOW_ORDINAL_WITH_CENTER_AND_ZOOM = "SHOW_ORDINAL_WITH_CENTER_AND_ZOOM";
const UPDATE_VIEWPORT = "UPDATE_VIEWPORT";
const ZOOM_IN = "ZOOM_IN";
const ZOOM_OUT = "ZOOM_OUT";
const RESET_NORTH = "RESET_NORTH";
const SHOW_LAYER_ERRORS = "SHOW_LAYER_ERRORS";
const WAYFINDING = "WAYFINDING";
const def = (type, ...argNames) => (...args) => mergeRight({ type }, zipObj(argNames, args));
const deselectAllFeatures = def(DESELECT_ALL_FEATURES);
const selectFeaturesForEntities = def(SELECT_FEATURES_FOR_ENTITIES, "entityIds");
const showOrdinal = def(SHOW_ORDINAL, "ordinalId");
const showOrdinalWithCenterAndZoom = def(SHOW_ORDINAL_WITH_CENTER_AND_ZOOM, "ordinal", "latitude", "longitude", "zoom");
const updateViewport = def(UPDATE_VIEWPORT, "viewport");
const zoomIn = def(ZOOM_IN);
const zoomOut = def(ZOOM_OUT);
const resetNorth = def(RESET_NORTH);
const showLayerErrors = def(SHOW_LAYER_ERRORS);
const wayfinding = def(WAYFINDING);
const setMapboxMap = (_mapboxMap, venueId, viewportChanges) => (dispatch, getState) => {
	global.mapboxMap = _mapboxMap;
	if (!Functional.pathString("map.loaded", getState())) dispatch(updateViewportWithClampedBounds(venueId, viewportChanges));
};
const zoomToEntity = (entityId, andSelect = true) => (dispatch, getState) => {
	const position = LandscapeState.selectors.positionForEntity(entityId.replace(/#/, ""), getState());
	if (!position.levelId) return;
	dispatch(showOrdinalFromIdOrNumberWithViewport(LandscapeState.selectors.ordinalForLevel(position.levelId, getState()), position.lat, position.lng, 20));
	if (andSelect) dispatch(actions.selectFeaturesForEntities([entityId]));
};
const zoomToMapNote = (mapNote) => (dispatch) => {
	const { location } = mapNote;
	dispatch(showOrdinalFromIdOrNumberWithViewport(location.ordinalId, location.latitude, location.longitude, 20));
};
/**
* Zoom to show the bounding box of the specified structure
* Dispatches
* @sig zoomToStructure :: StructureId -> (Dispatch, GetState) -> ()
*/
const zoomToStructure = (venueId, structureId) => (dispatch, getState) => {
	const state = getState();
	const boundingBox = LandscapeState.selectors.getBoundingBoxForStructure(structureId, state);
	dispatch(updateViewportWithClampedBounds(venueId, zoomToBoundingBox(selectors.getViewport(state), boundingBox, TRANSITION_DURATION)));
};
const zoomToLocationOrVenueCenter = (venueId, location) => (dispatch, getState) => {
	const state = getState();
	const boundingBox = LandscapeState.selectors.getBoundingBoxForVenue(venueId, getState());
	const viewport = zoomToBoundingBox(selectors.getViewport(state), boundingBox, 0);
	const venue = LandscapeState.selectors.getVenue(venueId, state);
	const ordinals = LandscapeState.selectors.ordinalsForVenue(venueId, state);
	const defaultOrdinalNumber = Ordinal.getDefaultOrdinalForVenue(ordinals).ordinalNumber;
	const query = defaultTo({}, location.query);
	const n = (x) => Number.isNaN(x - 0) ? null : x - 0;
	const ordinal = defaultTo(defaultOrdinalNumber, query.ordinal);
	const lat = defaultTo(venue.venueCenter[0], query.lat);
	const lng = defaultTo(venue.venueCenter[1], query.lng);
	const zoom = defaultTo(viewport.zoom, query.zoom);
	dispatch(updateViewportWithClampedBounds(venueId, { minZoom: viewport.zoom }));
	dispatch(showOrdinalFromIdOrNumberWithViewport(ordinal, n(lat), n(lng), n(zoom)));
};
const showOrdinalFromIdOrNumberWithViewport = (ordinalOrIdOrNumber, latitude, longitude, zoom) => (dispatch, getState) => {
	const ordinal = LandscapeState.selectors.getOrdinalFromOrdinalOrIdOrNumber(ordinalOrIdOrNumber, getState());
	dispatch(actions.showOrdinalWithCenterAndZoom(ordinal, latitude, longitude, zoom));
};
const updateViewportWithClampedBounds = (venueId, viewport) => (dispatch, getState) => {
	dispatch(updateViewport(clampBounds(viewport, LandscapeState.selectors.getBoundingBoxForBasemap(venueId, getState()))));
};
const showLevel = (levelId) => (dispatch, getState) => dispatch(showOrdinal(LandscapeState.selectors.ordinalForLevel(levelId, getState()).id));
const featuresToSource = (features) => ({
	type: "geojson",
	data: {
		type: "FeatureCollection",
		features
	}
});
const addSourcesToBaseStyle = (baseStyle, sources) => {
	sources = map(featuresToSource, sources);
	return assoc("sources", sources, baseStyle);
};
const _getMapStyle = (masterState) => {
	const LANDSCAPE_BACKGROUND = Ordinal.LANDSCAPE_BACKGROUND;
	const NO_ORDINAL = "NO_ORDINAL";
	const { currentOrdinalId, selectedEntityIds } = masterState.map;
	const ordinal = LandscapeState.selectors.getOrdinal(currentOrdinalId, masterState, false);
	const ordinalSource = ordinal ? ordinal.id : NO_ORDINAL;
	return addSourcesToBaseStyle((LandscapeState.selectors.getMapStyle(masterState) || defaultMapStyle)(ordinalSource, selectedEntityIds), {
		[LANDSCAPE_BACKGROUND]: LandscapeState.selectors.featuresForBackground(),
		[ordinalSource]: LandscapeState.selectors.featuresForOrdinal(currentOrdinalId),
		[NAV_LINE_SOURCE]: navlineFeatures(masterState.map),
		[MAP_NOTES_SOURCE]: Selectors.getConvertedMapNoteletsAsGeoJson(masterState, ordinal)
	});
};
const hasMapStyleChanged = (masterState) => {
	const { currentOrdinalId, selectedEntityIds, wayfinding } = masterState.map;
	const ordinal = getCurrentOrdinal(masterState);
	return {
		lastChangedAt: LandscapeState.selectors.getLastChangedAt(masterState),
		currentOrdinalId,
		selectedEntityIds,
		wayfinding,
		mapNoteGeoJson: Selectors.getConvertedMapNoteletsAsGeoJson(masterState, ordinal)
	};
};
const getMapStyle = Functional.memoizeOnceWithObject(hasMapStyleChanged, _getMapStyle);
const levelAtLatLng = (masterState, venueId, latLng, pickOneAnyway = false) => LandscapeState.selectors.levelAtLatLng(venueId, latLng, masterState.map.currentOrdinalId, masterState, pickOneAnyway);
const levelAtCenter = (venueId, state) => levelAtLatLng(state, venueId, LatLng.fromLatitudeAndLongitude(state.map.viewport));
const getMapLoaded = (venueId, state) => {
	return path([
		"map",
		"loaded",
		venueId
	], state) === "LOADED";
};
const getCurrentOrdinal = (masterState) => LandscapeState.selectors.getOrdinal(masterState.map.currentOrdinalId, masterState, false);
const getCurrentOrdinalNumber = (masterState) => prop("ordinalNumber", getCurrentOrdinal(masterState));
const initialState = () => ({
	selectedEntityIds: SELECT_NO_ENTITIES,
	viewport: {
		zoom: 15,
		transitionDuration: 0,
		maxZoom: 22,
		minZoom: 15,
		width: 800,
		height: 600
	},
	currentOrdinalId: void 0,
	wayfinding: {
		startLocation: "",
		endLocation: "",
		segments: []
	},
	loaded: {}
});
const handleUpdateViewport = (state, action) => Functional.mergeWithProp("viewport", action.viewport, state);
const changeZoom = (delta) => (state) => {
	const { minZoom = 15, maxZoom = 22, zoom } = state.viewport;
	return assocPath(["viewport", "zoom"], clamp(minZoom, maxZoom, zoom + delta), state);
};
const handleZoomIn = changeZoom(1);
const handleZoomOut = changeZoom(-1);
const handleResetNorth = (state) => {
	const viewport = {
		pitch: 0,
		bearing: 0,
		transitionDuration: TRANSITION_DURATION
	};
	return Functional.mergeWithProp("viewport", viewport, state);
};
const setCurrentOrdinalId = (state, ordinalId) => ordinalId === state.currentOrdinalId ? state : assoc("currentOrdinalId", ordinalId, state);
const handleShowOrdinal = (state, action) => setCurrentOrdinalId(state, action.ordinalId);
const handleShowOrdinalWithCenterAndZoom = (state, action) => {
	const viewport = {
		latitude: action.latitude,
		longitude: action.longitude,
		zoom: action.zoom
	};
	if (!isEmpty(state.loaded)) viewport.transitionDuration = TRANSITION_DURATION;
	return mergeDeepRight(state, {
		currentOrdinalId: action.ordinal.id,
		viewport
	});
};
/**
* Highlight all the features associated with each entityId by updating the selectedEntityIds
*/
const handleSelectFeaturesForEntities = (state, action) => assoc("selectedEntityIds", action.entityIds, state);
/**
* Unhighlight all the features by resetting the selectedEntityIds
*/
const handleDeselectAllFeatures = (state) => assoc("selectedEntityIds", SELECT_NO_ENTITIES, state);
const handleWayfinding = (state) => assoc("wayfinding", navigate(), state);
const handleShowLayerErrors = (state) => {
	validateFeaturesOnLayer(global.mapboxMap.queryRenderedFeatures());
	return state;
};
const handleLoadingFinished = (state, action) => {
	const { latitude, longitude } = state.viewport;
	return {
		...state,
		viewport: {
			...state.viewport,
			latitude,
			longitude
		},
		loaded: {
			...state.loaded,
			[action.venueId]: "LOADED"
		}
	};
};
const handleReset = (state) => Functional.mergeWithProp("viewport", pick(["width", "height"], state.viewport), initialState());
const reducer = (state = initialState(), action) => {
	switch (action.type) {
		case LandscapeState.actions.RESET: return handleReset(state);
		case LandscapeState.actions.PERFORM_VALIDATION: return handleShowLayerErrors(state);
		case DESELECT_ALL_FEATURES: return handleDeselectAllFeatures(state);
		case SELECT_FEATURES_FOR_ENTITIES: return handleSelectFeaturesForEntities(state, action);
		case SHOW_ORDINAL: return handleShowOrdinal(state, action);
		case UPDATE_VIEWPORT: return handleUpdateViewport(state, action);
		case ZOOM_IN: return handleZoomIn(state);
		case ZOOM_OUT: return handleZoomOut(state);
		case SHOW_ORDINAL_WITH_CENTER_AND_ZOOM: return handleShowOrdinalWithCenterAndZoom(state, action);
		case VENUE_LOADING_FINISHED: return handleLoadingFinished(state, action);
		case RESET_NORTH: return handleResetNorth(state);
		case SHOW_LAYER_ERRORS: return handleShowLayerErrors(state);
		case WAYFINDING: return handleWayfinding(state);
		default: return state;
	}
};
const selectors = {
	getMapStyle,
	getMapLoaded,
	getViewport: Functional.pathString("map.viewport"),
	getCurrentOrdinalNumber,
	levelAtLatLng,
	levelAtCenter,
	determineMapClickAction: (mode, event) => determineMapClickAction(mode, event.features)
};
const actions = {
	selectFeaturesForEntities,
	deselectAllFeatures,
	resetNorth,
	setMapboxMap,
	showLayerErrors,
	wayfinding,
	showLevel,
	showOrdinal,
	showOrdinalWithCenterAndZoom,
	updateViewport,
	zoomIn,
	zoomOut,
	zoomToEntity,
	zoomToMapNote,
	zoomToStructure,
	zoomToLocationOrVenueCenter
};
const thunks = { updateViewportWithClampedBounds };
//#endregion
export { actions, reducer, selectors, thunks };

//# sourceMappingURL=index.mjs.map